<template>
    <div class="d-flex flex-column align-items-center fade-in">
      <div v-if="!processingPayment" class="payment-container">
        <content-header :title="`${requirePayment ?  'Summary & Payment' : 'Summary'}`" :sub-title="subTitle" class="w-100 mxw-lg px-10"/>
        <div class="d-flex justify-content-center w-100 mb--10" v-if="isLoaded">
          <el-row class="payment-container" :gutter="20">
            <el-col class="mt-10" v-bind="resCol">
              <content-body-card>
                <content-header title="Registration Summary" class="fs-09 mt--10"/>
                <div class="mb--05">
                  <div v-if="summary.length">
                    <div class="mt-10" v-for="(rego, idx) in summary" :key="idx">
                      <el-divider content-position="left" class="my-15">Registration Details</el-divider>
                      <el-card class="compact-card mt-05" shadow="never">
                        <div class="card-content">
                          <div class="card-item"><span class="title">Name:</span>{{ rego | parseEntityName }}</div>
                          <div class="card-item"><span class="title">Registration Type:</span>{{ rego.registrationType | cap }}</div>
                          <div class="card-item"><span class="title">Product Type:</span>{{ rego.productType | parseProductType }}</div>
                          <div class="card-item"><span class="title">Member Type:</span>{{ rego.memberType | cap }}</div>
                          <div class="card-item" v-if="rego.tags && rego.tags.length > 0"><span class="title">Tags:</span>{{ rego.tags | joinTag }}</div>
                        </div>
                      </el-card>
                      <el-divider content-position="left" class="my-15" >Registering Members</el-divider>
                      <div class="fs-15">
                        <div class="fs-15">
                        <el-table
                          max-height="250"
                          :data="memberDetails(rego)"
                          style="width: 100%"
                          border
                        >
                          <el-table-column prop="profile.firstName" label="First Name"></el-table-column>
                          <el-table-column prop="profile.lastName" label="Last Name"></el-table-column>
                          <el-table-column prop="profile.dob" label="DOB"></el-table-column>
                          <el-table-column prop="profile.gender" label="Gender"></el-table-column>
                          <el-table-column label="" width="70">
                            <template v-slot="scope">
                              <div class="action-cell">
                                <el-button
                                  type="danger"
                                  size="mini"
                                  @click="removeMember(rego, scope.row._id)"
                                  class="delete-button"
                                >
                                  <i class="el-icon-delete"></i>
                                </el-button>
                              </div>
                            </template>
                            </el-table-column>
                          </el-table>
                        </div>
                      </div>
                      <el-divider content-position="left" class="my-15">Payment Details</el-divider>
                      <div :class="{'pay-later-wrapper': rego.allowPayLater, 'pay-later-selected': summary[idx].payLater}">
                        <div class="pay-later-checkbox">
                          <el-checkbox v-if="rego.allowPayLater" @change="updatePayLater(rego,idx)">
                            Pay Later
                            <el-tooltip content="Select to make offline payment to your organisation" placement="top" effect="light">
                              <i class="el-icon-info"></i>
                            </el-tooltip>
                          </el-checkbox>
                        </div>
                        <!-- <div class="pay-later-text">
                          Select to make offline payment to your organisation
                        </div> -->
                        <div class="card-container">
                        <el-card body-style="padding: 0;" class="item-card"  shadow="never">
                          <div slot="header"  >
                          <el-row type="flex" justify="space-between" >
                          <el-col :span="13" :xs="24">
                            <span>Product</span>
                          </el-col>
                          <el-col v-if="requirePayment" :span="4" :xs="0">
                            <span>Price</span>
                          </el-col>
                          <el-col :span="4" :xs="0" >
                            <span>QTY</span>
                          </el-col>
                          <el-col v-if="requirePayment" :span="4" :xs="0" class="text-center">
                            <span>Cost</span>
                          </el-col>
                          </el-row>
                          </div>
                          <div class="card-body-container" >
                          <div class="card-body"   v-for="(product,index) in rego.products" :key="product.name" >
                          <el-row type="flex" justify="space-between" class="mb-10 align-items-center ">
                            <el-col :span="13" :xs="0" >
                              <span>{{ product.name }}</span>
                            </el-col>
                            <el-col :span="24" :xs="24" :lg="0" :md="0" >
                              <div class="header mb--10">{{ product.name }}</div>
                              <el-row class="mb-05">
                                <el-col :span="3">
                                  <span class="title">Price:</span>
                                </el-col>
                                <el-col :span="6" :offset="3" v-if="product.price && !isNaN(product.price)" >
                                {{ product.price | parsePrice }}
                                </el-col>
                                </el-row>
                              <el-row class="mb-05 align-items-center text-center d-flex">
                                <el-col :span="3">
                                  <span class="title">QTY:</span>
                                </el-col>
                                <el-col v-if="product.isSaleableItem" :span="6" :offset="3">
                                  <el-qty-input v-model="product.qty" :disabled="!product.isSaleableItem "/>
                                </el-col>
                              </el-row>
                              <el-row class="mb-05">
                                <el-col :span="3">
                                  <span class="title">Subtotal:</span>
                                </el-col>
                                <el-col :span="6" :offset="3">
                                  {{ product.total * product.qty | parsePrice }}
                                </el-col>
                              </el-row>
                              <el-row class="mb-05">
                                <el-col :span="6" :offset="18">
                                  <el-button  v-if="product.isSaleableItem " title="update"  type="text"  @click="updateQty(idx, product, index)" :disabled="noQtyChanged(idx, product, index)">
                                    <i class="el-icon-check"></i>
                                  </el-button>
                                  <el-button class="" v-if="product.isSaleableItem " :disabled="!noQtyChanged(idx, product, index)" title="delete"  type="text" icon="el-icon-delete" @click="deleteSaleableItem(idx, product, index)"></el-button>
                                </el-col>
                              </el-row>
                              <el-divider></el-divider>
                            </el-col>
                            <el-col v-if="requirePayment" :span="4" :xs="0">
                              <span v-if="product.price && !isNaN(product.price)">{{ product.price | parsePrice }}</span>
                            </el-col>
                            <el-col v-if="product.isSaleableItem" :span="4" :xs="0">
                              <el-qty-input v-model="product.qty" :disabled="isQtyDisabled(product)"/>
                            </el-col>
                            <el-col class="text-center" v-else :span="4" :xs="0">
                              <el-input v-model="product.qty" :disabled="isQtyDisabled(product)"/>
                            </el-col>
                            <el-col v-if="requirePayment" :span="4" :xs="0" class="text-center">
                            <div class="d-flex flex-column text-center"></div>
                              <span >
                                {{  product.total | parsePrice }}

                                <el-button  v-if="get(product, 'feeRequired') !== undefined && get(product, 'feeRequired') === false" title="update"  type="text"  @click="updateCstmFeeQty(idx, product)">
                                  <i class="el-icon-check"></i>
                                </el-button>
                              </span>
                            </el-col>
                          </el-row>
                          <el-row v-if="get(product, 'subProducts', []).length" class="sub-products-list">
                            <el-col :span="24">
                              <div class="sub-products-title">Sub Products:</div>
                              <ul class="sub-products-names inline-list">
                                <li v-for="(subProduct, subIndex) in product.subProducts" :key="subIndex">
                                  {{ subProduct.name }}
                                </li>
                              </ul>
                            </el-col>
                          </el-row>
                          <el-row>
                            <el-col :span="6" :offset="18" class="text-right" :xs="0">
                              <span class="p-0">
                                  <el-button  v-if="product.isSaleableItem " title="update"  type="text"  @click="updateQty(idx, product, index)" :disabled="noQtyChanged(idx, product, index)">
                                    <i class="el-icon-check"></i>
                                  </el-button>
                                  <el-button class="" v-if="product.isSaleableItem" :disabled="!noQtyChanged(idx, product, index)" title="delete"  type="text" icon="el-icon-delete" @click="deleteSaleableItem(idx, product, index)"></el-button>
                                </span>
                            </el-col>
                          </el-row>
                          </div>
                          <!-- <div v-if="payLaterSelected[idx]" class="overlay">
                            <div class="overlay-text">Pay Later Selected</div>
                          </div> -->
                          </div>
                        </el-card>
                        </div>
                      </div>
                      <div class="mb-15 mt-15" v-if="rego && rego.payAfter">
                      <h3 class="f-light mt--05">Pay After Details</h3>
                      <small> Minimum Payment: <b>{{ rego.minPrice | parsePrice }}</b> </small>
                      <el-row class="d-flex align-items-center mt-15" v-if="rego && rego.total">
                        <el-col :span="19" :md="12">
                          <el-price-input v-model="rego.payToday" :min="rego.minPrice" :max="rego.total" />
                        </el-col>
                        <h1 class="price-divider ml-05"> / </h1>
                        <el-col :span="5" :md="2" class="ml-05">
                          <h3>{{ rego.total | parsePrice }}</h3>

                        </el-col>
                      </el-row>
                      </div>
                    <div v-if="rego && rego.total > 0" class="d-flex justify-content-end mt-05">
                        <span v-if="voucherAvailable(rego)" class="f-light ml-10 text-underline pointer" @click="[6,9].includes(nationalId) ? showVICActiveKidsModal(idx) : showActiveKidsModal(idx)">+ Add Active Kids Voucher</span>
                        <span v-if="additionalVoucherAvailable(rego, idx)" class="f-light ml-10 text-underline pointer" @click="showAdditionalActiveKidsModal(idx)">+ Add 2nd Active Kids Voucher</span>
                    </div>
                      <!-- <div class="mb-15 mt-15" >
                      <h3 class="f-light mt--05">{{ rego.donation.label }}</h3>
                      <el-row class="d-flex align-items-center mt-15">
                        <el-col :span="19" :md="12">
                          <el-price-input v-model="donate"  />
                        </el-col>
                      </el-row>
                    </div> -->

                      <!-- <div class="redeem" v-if="rego.discountVoucher">
                        <div class="mt-10 d-flex justify-content-between">
                          <el-input v-model="rego.discountVoucher.code" :disabled="rego.discountVoucher && rego.discountVoucher.redeemed" class="discount-code" placeholder="Enter your discount code" ></el-input>
                          <el-button type="primary" v-if="!rego.discountVoucher || !rego.discountVoucher.redeemed" class="ml-10" @click="redeem(idx)">Redeem Code</el-button>
                          <el-button type="primary" v-else class="ml-10" @click="cancelRedeemed(idx)">Cancel Code</el-button>
                        </div>
                        <span v-if="rego.discountVoucher && rego.discountVoucher.error" class="font-light text-danger">{{ rego.discountVoucher.error }}</span>
                      </div> -->
                      <div class="d-flex justify-content-center mt-10">
                        <!-- <el-button type="primary" class="bottomBtn" @click="edit" disabled>Edit</el-button> -->
                        <el-button type="primary" class="btn-highlight bottomBtn" @click="remove(idx, rego.productType)">Remove</el-button>
                        <el-button type="primary" class="btn-highlight bottomBtn" @click="edit(idx, rego.productType)">Edit</el-button>
                      </div>
                      <!-- <el-divider class="mt-10" /> -->
                    </div>
                  </div>

                  <!-- <div class="d-flex justify-content-between fs-07" v-if="![4, 7].includes(national) && feePercentage && !payment.directSaleableItems.length">
                    <h3>*A ~{{ feePercentage }}% transaction fee will apply to all online payments.</h3>
                  </div>
                  <div v-if="!payment.directSaleableItems.length" class="d-flex justify-content-between fs-07">
                    <h2>Discount Total:</h2>
                    <h2>{{ discountTotal | parsePrice }}</h2>
                  </div>
                  <div v-if="!payment.directSaleableItems.length" class="d-flex justify-content-between fs-09">
                    <h2>Cart Total:</h2>
                    <h2>{{totalWithSaleableItems | parsePrice}}</h2>
                  </div> -->
                </div>
              </content-body-card>
              <content-body-card class="mt-10" v-if="payment.directSaleableItems.length">
                <content-header title="Store Summary" class="fs-09 mt--20" />
                <div class="mb--05">
                  <!-- div for saleableItems -->
                  <div class="mt-10" >
                    <el-card class="item-card" shadow="never">
                      <div slot="header"  >
                      <el-row type="flex" justify="space-between" >
                      <el-col :span="13" :xs="24">
                        <span>Product</span>
                      </el-col>
                      <el-col :span="4" :xs="0">
                        <span>Price</span>
                      </el-col>
                      <el-col :span="4" :xs="0" >
                        <span>QTY</span>
                      </el-col>
                      <el-col  :span="4" :xs="0" class="text-center">
                        <span>Cost</span>
                      </el-col>
                      </el-row>
                      </div>
                      <div v-for="(item, idx) in payment.directSaleableItems" :key="idx" >
                      <el-row type="flex" justify="space-between" class="mb-20 align-items-center ">
                        <el-col :span="13" :xs="0" >
                          <span>{{ item.name }}</span>
                        </el-col>
                        <el-col :span="24" :xs="24" :lg="0" :md="0" >
                          <div class="header mb--10">{{ item.name }}</div>
                          <el-row class="mb-05">
                            <el-col :span="3">
                              <span class="title">Price:</span>
                            </el-col>
                            <el-col :span="6" :offset="3">
                            {{ item.price | parsePrice }}
                            </el-col>
                            </el-row>
                          <el-row class="mb-05 align-items-center text-center d-flex">
                            <el-col :span="3">
                              <span class="title">QTY:</span>
                            </el-col>
                            <el-col :span="6" :offset="3">
                              <el-qty-input v-model="item.qty" />
                            </el-col>
                          </el-row>
                          <el-row class="mb-05">
                            <el-col :span="3">
                              <span class="title">Subtotal:</span>
                            </el-col>
                            <el-col :span="6" :offset="3">
                              {{ item.price * item.qty | parsePrice }}
                            </el-col>
                          </el-row>
                          <!-- <el-row class="mb-05">
                            <el-col :span="6" :offset="18">
                              <el-button   title="update"  type="text"  @click="updateQty(idx, product, index)" :disabled="noQtyChanged(idx, product, index)">
                                <i class="el-icon-check"></i>
                              </el-button>
                              <el-button class=""  :disabled="!noQtyChanged(idx, product, index)" title="delete"  type="text" icon="el-icon-delete" @click="deleteSaleableItem(idx, product, index)"></el-button>
                            </el-col>
                          </el-row> -->
                          <el-divider></el-divider>
                        </el-col>
                        <el-col :span="4" :xs="0">
                          <span v-if="item.price && !isNaN(item.price)">{{ item.price | parsePrice }}</span>
                        </el-col>
                        <el-col :span="4" :xs="0">
                          <el-qty-input v-model="item.qty" />
                        </el-col>
                        <el-col :span="4" :xs="0" class="text-center">
                        <div class="d-flex flex-column text-center"></div>
                          <span >
                            {{ item.price * item.qty | parsePrice }}

                            <!-- <el-button  v-if="get(product, 'feeRequired') !== undefined && get(product, 'feeRequired') === false" title="update"  type="text"  @click="updateCstmFeeQty(idx, product)">
                              <i class="el-icon-check"></i>
                            </el-button> -->
                          </span>
                        </el-col>
                      </el-row>
                      <el-row>
                        <el-col :span="6" :offset="18" class="text-right" :xs="0">
                          <span class="p-0">
                              <el-button   title="update"  type="text"  @click="updateDirectQty(item, idx)">
                                <i class="el-icon-check"></i>
                              </el-button>
                              <el-button class=""   title="delete"  type="text" icon="el-icon-delete" @click="deleteDirectSaleableItem(item, idx)"></el-button>
                            </span>
                        </el-col>
                      </el-row>
                      </div>

                    </el-card>
                    <!-- <div class="d-flex justify-content-center mt-10">
                      <el-button type="primary" class="btn-highlight bottomBtn" @click="remove(idx)">Remove</el-button>
                    </div> -->
                    <el-divider class="mt-10" />
                  </div>

                  <div class="d-flex justify-content-between fs-07" v-if="![4, 7].includes(national) && feePercentage">
                    <h3>*A ~{{ feePercentage }}% transaction fee will apply to all online payments.</h3>
                    <!-- <h2>Transaction Fee</h2>
                    <h2>${{transactionFee | parsePrice}}</h2> -->
                  </div>
                  <div class="d-flex justify-content-between fs-07">
                    <h2>Discount Total:</h2>
                    <h2>{{ discountTotal | parsePrice }}</h2>
                  </div>
                  <div class="d-flex justify-content-center mt-10">
                    <!-- <el-button type="primary" class="bottomBtn" @click="edit" disabled>Edit</el-button> -->
                    <!-- <el-button type="primary" class="btn-highlight bottomBtn" @click="remove(idx, rego.productType)">Remove</el-button> -->
                  </div>
                  <el-divider class="mt-10" />
                  <div class="mb-15 mt-15" v-if="rego && rego.payAfter">
                  <h3 class="f-light mt--05">Pay After Details</h3>
                  <small> Minimum Payment: <b>{{ rego.minPrice | parsePrice }}</b> </small>
                  <el-row class="d-flex align-items-center mt-15" v-if="rego && rego.total">
                    <el-col :span="19" :md="12">
                      <el-price-input v-model="rego.payToday" :min="rego.minPrice" :max="rego.total" />
                    </el-col>
                    <h1 class="price-divider ml-05"> / </h1>
                    <el-col :span="5" :md="2" class="ml-05">
                      <h3>{{ rego.total | parsePrice }}</h3>
                    </el-col>
                  </el-row>
                  <div class="mb-15 mt-15" v-if="rego && rego.payAfter">
                  <h3 class="f-light mt--05">Pay After Details</h3>
                  <small> Minimum Payment: <b>{{ rego.minPrice | parsePrice }}</b> </small>
                  <el-row class="d-flex align-items-center mt-15" v-if="rego && rego.total">
                    <el-col :span="19" :md="12">
                      <el-price-input v-model="rego.payToday" :min="rego.minPrice" :max="rego.total" />
                    </el-col>
                    <h1 class="price-divider ml-05"> / </h1>
                    <el-col :span="5" :md="2" class="ml-05">
                      <h3>{{ rego.total * rego.qty | parsePrice }}</h3>
                    </el-col>
                  </el-row>
                </div>
                </div>
                  <!-- <div class="mb-15 mt-15" >
                  <h3 class="f-light mt--05">{{ rego.donation.label }}</h3>
                  <el-row class="d-flex align-items-center mt-15">
                    <el-col :span="19" :md="12">
                      <el-price-input v-model="donate"  />
                    </el-col>
                  </el-row>
                  </div> -->

                  <!-- <div class="redeem" v-if="rego.discountVoucher">
                    <div class="mt-10 d-flex justify-content-between">
                      <el-input v-model="rego.discountVoucher.code" :disabled="rego.discountVoucher && rego.discountVoucher.redeemed" class="discount-code" placeholder="Enter your discount code" ></el-input>
                      <el-button type="primary" v-if="!rego.discountVoucher || !rego.discountVoucher.redeemed" class="ml-10" @click="redeem(idx)">Redeem Code</el-button>
                      <el-button type="primary" v-else class="ml-10" @click="cancelRedeemed(idx)">Cancel Code</el-button>
                    </div>
                    <span v-if="rego.discountVoucher && rego.discountVoucher.error" class="font-light text-danger">{{ rego.discountVoucher.error }}</span>
                  </div> -->
                  <div v-if="rego && rego.total > 0" class="d-flex justify-content-end mt-05">
                    <!-- <span class="f-light text-underline pointer">+ Add Discount</span> -->
                    <span v-if="voucherAvailable(rego)" class="f-light ml-10 text-underline pointer" @click="[6,9].includes(nationalId) ? showVICActiveKidsModal(idx) : showActiveKidsModal(idx)">+ Add Active Kids Voucher</span>
                  </div>
                  <!-- <div class="d-flex justify-content-center mt-10">
                    <el-button type="primary" class="bottomBtn" @click="edit" disabled>Edit</el-button>
                    <el-button type="primary" class="btn-highlight bottomBtn" @click="remove(idx, rego.productType)">Remove</el-button>
                  </div> -->
                </div>
              </content-body-card>
              <content-body-card v-if="requirePayment" class="mt-10">
                <div class="d-flex justify-content-between fs-07" v-if="![4, 7].includes(national) && feePercentage">
                  <h3>*A {{ feePercentage }}% transaction fee will apply to all online payments.</h3>
                  <!-- <h2>Transaction Fee</h2>
                  <h2>${{transactionFee | parsePrice}}</h2> -->
                </div>
                <!-- Checkout Total Discount -->
                <div v-for="discount of regoDiscounts" :key="discount._id">
                  <div class="mt-10 d-flex justify-content-between">
                    <el-input size="small" v-model="discount.discountVoucher.code" :disabled="discount.discountVoucher && discount.discountVoucher.redeemed" class="discount-code" placeholder="Enter your checkout total discount code" ></el-input>
                    <el-button type="primary" size="small" v-if="!discount.discountVoucher || !discount.discountVoucher.redeemed" class="ml-10" @click="initRedeem(discount._id)">Redeem Code</el-button>
                    <el-button type="primary" size="small" v-else class="ml-10" @click="cancelRedeemedNew(discount.discountVoucher)">Cancel Code</el-button>
                    <el-button type="primary" size="small" :disabled="discount.discountVoucher.redeemed" v-if="regoDiscounts.length > 1" class="ml-10" @click="removeAdditionalVoucher(discount._id)">Remove Code</el-button>
                  </div>
                  <span v-if="discount.discountVoucher && discount.discountVoucher.error" class="font-light text-danger">{{ discount.discountVoucher.error }}</span>
                </div>
                <div class="d-flex justify-content-end mt-05">
                  <!-- <span class="f-light text-underline pointer">+ Add Discount</span> -->
                  <span class="f-light ml-10 text-underline pointer" @click="newDiscountVoucher">+ Apply Additional Voucher</span>
                </div>

                <div class="d-flex justify-content-between fs-07">
                  <h2>Discount Total:</h2>
                  <h2>{{ discountTotal | parsePrice }}</h2>
                </div>
                <!-- <div class="d-flex justify-content-center mt-10"> -->
                <div class="d-flex justify-content-center mt-10">
                  <!-- <el-button type="primary" class="bottomBtn" @click="edit" disabled>Edit</el-button> -->
                  <!-- <el-button type="primary" class="btn-highlight bottomBtn" @click="remove(idx, rego.productType)">Remove</el-button> -->
                </div>
                <el-divider class="mt-10" />
                <!-- </div> -->
                <div class="d-flex justify-content-between fs-07" v-if="![4, 7].includes(national) && feePercentage">
                  <h3>*A {{ feePercentage }}% transaction fee will apply to all online payments.</h3>
                  <!-- <h2>Transaction Fee</h2>
                  <h2>${{transactionFee | parsePrice}}</h2> -->
                </div>
                <div class="d-flex justify-content-between fs-07">
                  <h2>Discount Total:</h2>
                  <h2>{{ discountTotal | parsePrice }}</h2>
                </div>
                <div class="d-flex justify-content-between fs-09">
                  <h2>Cart Total:</h2>
                  <h2>{{totalWithSaleableItems | parsePrice}}</h2>
                </div>
              </content-body-card>
          </el-col>
          <el-col class="mt-10" :xs="24" :sm="24" :md="12" :lg="12">
              <content-body-card v-if="requirePayment">
                <content-header :title="paymentTitle" class="fs-09 mt--10"/>
                <el-row v-if="nationalId === 1 || nationalId === 18">
                  <div class="vendor-payment text-center mb-10" :class="{ single: !canShowApple && isNotFirefox }">
                    <GooglePayButton
                      id="google-pay-btn"
                      :options="options"
                      v-if="isNotFirefox"
                      @payed="payGoogle($event)"
                      @cancel="handleCancel"
                    />
                    <div class="apple-button">
                      <!-- disabling for now -->
                      <apple-pay-button v-if="canShowApplePay" buttonstyle="black" type="plain" lang="en" @click.stop="startApplePaySession"></apple-pay-button>
                    </div>
                  </div>
                </el-row>
                <el-divider class="mt-10 mb-20"><span class="mx-2" v-if="canShowApplePay || isNotFirefox">OR</span></el-divider>
                <el-form ref="form" :model="payment" :rules="rules">
                  <div class="mb-10">
                    <h3 class="f-light mt--05">Credit Card Details</h3>
                    <!-- <small v-if="nationalId !==1"> *International Credit Cards are not accepted </small> -->
                    <credit-card v-model="payment.card" ref="card" :width="300" data-dd-privacy="hidden"/>
                    <el-divider />
                    <div class="d-flex align-items-center " style="height: 30px; margin-bottom: 20px;">
                    <h3 class="f-light mr-10">
                      Billing Address
                    </h3>
                      <el-button
                        class="py-0 fs-09 op-7 manualAddressBtn"
                        type="text"
                        @click="manualAddress"
                      >
                        {{
                          payment.billingAddress.isManual
                            ? "Search Address"
                            : "Enter Address Manually"
                        }}
                      </el-button>

                  </div>
                  <div id="auto-fill" class="mt--10" v-if="fillingAddress">
                      <span type="text" class=" auto-fill text-underline c-highlight fs-09 pointer" @click="fillAddress(fillingAddress)">Fill address with {{ fillingAddress.formatted }}</span>
                    </div>
                    <el-row :gutter="20">
              <el-form-item prop="profile.address.formatted">
                <el-input
                  v-if="payment.billingAddress.isManual"
                  class="mt-05"
                  v-model="payment.billingAddress.formatted"
                  disabled
                />
                <google-auto-complete
                  v-else
                  class="auto-complete mt-05"
                  name="address"
                  id="map"
                  :key="1"
                  ref="address"
                  @change="checkAddress($event)"
                  v-model="payment.billingAddress.formatted"
                  placeholder="Enter an Address"
                >
                </google-auto-complete>
              </el-form-item>

                    <el-col :span="24" :md="12" class="mt-10" v-if="payment.billingAddress.isManual">
                        <el-input-title required>Address Line 1</el-input-title>
                        <el-form-item prop="billingAddress.addressLine1">
                          <el-input class="mt-05" v-model="payment.billingAddress.addressLine1" placeholder="Type here..." />
                        </el-form-item>
                      </el-col>
                      <el-col :span="24" :md="12" class="mt-10" v-if="payment.billingAddress.isManual">
                        <el-input-title>Address Line 2</el-input-title>
                        <el-form-item prop="billingAddress.addressLine2">
                          <el-input class="mt-05" v-model="payment.billingAddress.addressLine2" placeholder="Type here..." />
                        </el-form-item>
                      </el-col>
                      <el-col :span="24" :md="12" class="mt-10" v-if="payment.billingAddress.isManual">
                        <el-input-title required>City/Suburb</el-input-title >
                        <el-form-item prop="billingAddress.suburb">
                          <el-input class="mt-05" v-model="payment.billingAddress.suburb" placeholder="Type here..." />
                        </el-form-item>
                      </el-col>
                      <el-col :span="24" :md="12" class="mt-10" v-if="payment.billingAddress.isManual">
                        <el-input-title >State</el-input-title>
                        <el-form-item prop="billingAddress.state">
                          <el-input class="mt-05" v-model="payment.billingAddress.state" placeholder="Type here..." />
                        </el-form-item>
                      </el-col>
                      <el-col :span="24" :md="12" class="mt-10" v-if="payment.billingAddress.isManual">
                        <el-input-title required>Postcode</el-input-title>
                        <el-form-item prop="billingAddress.postcode">
                          <el-input class="mt-05" v-model="payment.billingAddress.postcode" placeholder="Type here..." />
                        </el-form-item>
                      </el-col>
                      <el-col :span="24" :md="12" class="mt-10" v-if="payment.billingAddress.isManual">
                        <el-input-title required>Country</el-input-title>
                        <el-form-item prop="billingAddress.country">
                          <el-autocomplete
                            class="mt-05 w-100"
                            v-model="payment.billingAddress.country"
                            :fetch-suggestions="searchCountry"
                            placeholder="Select"
                          ></el-autocomplete>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </div>
                </el-form>
              </content-body-card>
            </el-col>
            <el-col :span="24" class="d-flex justify-content-center mt-20">
              <el-button type="primary" class="btn-highlight payBtn" name="payBtn" @click.prevent="pay" :disabled="isPayDisabled">{{paymentButtonText}}</el-button>
            </el-col>
          </el-row>
          <!-- <el-row>
            <el-col :span="24" class="d-flex justify-content-center">
              <el-button type="primary" class="btn-highlight payBtn" @click.prevent="pay" :disabled="isPayDisabled">{{paymentButtonText}}</el-button>
            </el-col>
          </el-row> -->
        </div>
      </div>
      <el-dialog title="Active Kids Voucher" :visible.sync="activeKidsModalVisible" :before-close="handleActiveKidsClose" :close-on-click-modal="false">
        <div class="d-flex flex-column w-100">
          <el-form ref="activeKids" :model="activeKids" :rules="activeKidsRules">
            <el-row>
              <el-col :span="24">
                <el-input-title required>Voucher Number</el-input-title>
                <el-form-item prop="voucherNumber">
                  <el-input class="mt-05" v-model="activeKids.voucherNumber" placeholder="Type here..." />
                </el-form-item>
              </el-col>
              <!-- <el-col :span="24">
                <el-input-title required>PIN (Date of Birth - DDMM)</el-input-title>
                <el-form-item prop="pin">
                  <el-input class="mt-05" v-model="activeKids.pin" placeholder="Type here..." />
                </el-form-item>
              </el-col> -->
            </el-row>
            <div class="filter-btns d-flex flex-row justify-content-center">
              <el-button
              type="primary"
              class="w-25 bg-highlight bd-0"
              @click="addActiveKidsVoucher"
              >Add</el-button>
            </div>
          </el-form>
        </div>
      </el-dialog>

      <el-dialog title="Active Kids Voucher (VIC)" :visible.sync="victoriaActiveKidsVisible" :before-close="handleVictoriaActiveKidsClode" :close-on-click-modal="false">
        <div class="d-flex flex-column w-100">
          <el-form ref="victoriaActiveKids" :model="victoriaActiveKids" :rules="victoriaActiveKidsRules">
            <el-row>
              <el-col :span="24">
                <el-input-title required>Voucher Number (XX-XXXXXXX-XXXX)</el-input-title>
                <el-form-item prop="voucherNumber">
                  <el-input class="mt-05" v-model="victoriaActiveKids.voucherNumber" placeholder="Type here..." />
                </el-form-item>
              </el-col>
            </el-row>
            <div class="filter-btns d-flex flex-row justify-content-center">
              <el-button type="primary" class="w-25 bg-highlight bd-0" @click="addVICActiveKidsVoucher">Add</el-button>
            </div>
          </el-form>
        </div>
      </el-dialog>

        <el-dialog
        title="Add Additional Active Kids Voucher"
        :visible.sync="additionalActiveKidsModalVisible"
        width="30%"
      >
        <el-form ref="additionalActiveKids" :model="additionalActiveKids">
          <el-row>
            <el-col :span="24">
              <el-input-title required>Voucher Number</el-input-title>
              <el-form-item prop="voucherNumber">
                <el-input class="mt-05" v-model="additionalActiveKids.voucherNumber" placeholder="Type here..." />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="additionalActiveKidsModalVisible = false">Cancel</el-button>
          <el-button type="primary" @click="addAdditionalActiveKidsVoucher">Add Voucher</el-button>
        </span>
      </el-dialog>

      <el-dialog title="Select Which Registration Will Apply the Discount Code" :before-close="handleRegoSelectionClose" :visible.sync="productsDialogVisible" :close-on-click-modal="false">
        <span>
          <el-alert type="info" :closable="false">Selected {{ selectedProductCount }} / {{ this.limit }}</el-alert>
          <el-row>
            <el-col :span="24" class="mt-10" v-for="rego in availableProducts" :key="`${Math.random(1, 99999)-rego.entityId}`">
              <el-card v-if="rego.productType !== 'family'">
                <div>Name: {{ rego | parseEntityName}}</div>
                  <div>Registration Type: {{ rego.entityType | cap }}</div>
                  <div>Member: {{ rego.profile.firstName }} {{ rego.profile.lastName }}</div>
                  <div>Product Type: {{ rego.productType | parseProductType }}</div>
                  <div>Player: {{ rego.memberType | cap }}</div>
                  <el-checkbox v-model="productsForDiscount[`${rego.memberId}${rego.product._id}`]" :disabled="checkDiscountLimit(rego)" @change="regoSelected($event, rego)" label="Select This Registration" border></el-checkbox>
              </el-card>
              <el-card v-else>
                <div><span class="title">Name:</span>{{ rego | parseEntityName }}</div>
                <div><span class="title">Registration Type:</span>{{ rego.registrationType | cap }}</div>
                <div><span class="title">Product Type:</span>{{ rego.productType | parseProductType }}</div>
                <div v-if=" rego.tags && rego.tags.length > 0"><span class="title">Tags:</span>{{ rego.tags | joinTag }}</div>
                <el-table
                  :data="getFamilyMemberDetails(rego)"
                  style="width: 100%">
                  <el-table-column
                    prop="playerName"
                    label="Member"
                    width="180">
                  </el-table-column>
                  <el-table-column
                    prop="memberType"
                    label="Member Type"
                    width="180">
                    <template v-slot="scope">
                      {{ scope.row.memberType | cap }}
                    </template>
                  </el-table-column>
                </el-table>
                 <el-checkbox v-model="productsForDiscount[`${getFamilyMemberIds(rego)}${rego.product._id}`]" :disabled="checkDiscountLimit(rego)" @change="regoSelected($event, rego)" label="Select This Registration" border></el-checkbox>
              </el-card>
            </el-col>
          </el-row>
          <div class="filter-btns d-flex flex-row justify-content-center mt-10">
            <el-button type="primary" class="w-25 bg-highlight bd-0" @click="applyDiscountToSelectedEntity">Submit</el-button>
          </div>
        </span>
      </el-dialog>
      <!-- another dialog to ask if they want to donation the money -->
      <success v-if="processingPayment"
      :payment="payment"
      :token1="token1"
      :token2="token2"
      :cartTotal="cartTotal"
      :total="total"
      :payAfter="payAfter"
      :payTodayTotal="payTodayTotal"
      :totalSaleableItemsWithFee="totalSaleableItemsWithFee"
      />
    </div>
  </template>

<script>
/* eslint-disable object-shorthand */
/* eslint-disable object-shorthand */

import _ from 'lodash';
import moment from 'moment';
import { VueMaskDirective } from 'v-mask';
import { calculateMemberAge } from '@/utils/helpers';
import { errormsg, countries, productTypes } from '@/utils/constants';
import { mapGetters } from 'vuex';
import GooglePayButton from 'vue-google-pay';
import Success from './Success.vue';

const defaultRequiredRule = { required: true, trigger: 'blur', message: errormsg.required };
const initActiveKids = () => _.cloneDeep({
  regoIndex: undefined,
  voucherNumber: undefined,
  pin: undefined
});

const initVictoriaActiveKids = () => _.cloneDeep({
  regoIndex: undefined,
  voucherNumber: undefined,
});

const initDiscountCode = () => _.cloneDeep({
  error: '',
  code: '',
  redeemed: false,
  redeemedAmount: 0,
});

const parstAddressFormatted = (address) => {
  const {
    addressLine1,
    addressLine2,
    suburb,
    state,
    postcode,
    country
  } = address;
  return `${addressLine1}${
    addressLine2 ? ` ${addressLine2}` : ''
  }, ${suburb} ${state}, ${postcode}, ${country}`;
};

export default {
  name: 'Payment',
  props: {
    value: Object,
    isNewProduct: Boolean,
  },
  directives: {
    mask: VueMaskDirective
  },
  components: {
    GooglePayButton,
    Success
  },
  data() {
    return {
      get: _.get,
      nationalId: +process.env.VUE_APP_NATIONAL_ID,
      isLoaded: false,
      payToday: 0,
      token1: undefined,
      token2: undefined,
      processingPayment: false,
      donate: 0,
      subTitle: 'Please verify all the information displayed below is correct before proceeding.\xa0\xa0A receipt will be sent to the member\'s email address upon completion.',
      payment: {
        registrations: [],
        card: {},
        billingAddress: {
          isManual: false,
          formatted: undefined,
          addressLine1: undefined,
          addressLine2: undefined,
          suburb: undefined,
          state: undefined,
          postcode: undefined,
          country: undefined,
        },
        directSaleableItems: [],
      },
      summary: [],
      originalSummary: [],
      countries,
      rules: {
        'billingAddress.addressLine1': defaultRequiredRule,
        'billingAddress.suburb': defaultRequiredRule,
        'billingAddress.state': +process.env.VUE_APP_NATIONAL_ID === 17 ? {} : defaultRequiredRule,
        'billingAddress.postcode': defaultRequiredRule,
        'billingAddress.country': defaultRequiredRule,
      },
      additionalActiveKids: {
        regoIndex: null,
        voucherNumber: '',
        pin: ''
      },
      additionalActiveKidsModalVisible: false,
      activeKidsModalVisible: false,
      victoriaActiveKidsVisible: false,
      activeKids: initActiveKids(),
      victoriaActiveKids: initVictoriaActiveKids(),
      activeKidsRules: {
        voucherNumber: defaultRequiredRule,
        // pin: defaultRequiredRule
      },
      victoriaActiveKidsRules: {
        voucherNumber: defaultRequiredRule,
      },
      options: {
        environment: process.env.VUE_APP_PIN_ENV === 'test' ? 'TEST' : 'PRODUCTION',
        buttonColor: 'white',
        allowedCardNetworks: [
          'MASTERCARD',
          'VISA',
          'AMEX',
        ],
        allowedCardAuthMethods: ['PAN_ONLY', 'CRYPTOGRAM_3DS'],
        merchantInfo: {
          merchantName: 'Assemble Sports',
          merchantId: process.env.VUE_APP_GOOGLE_PAY_MERCHANT_ID,
        },
        tokenizationSpecification: {
          type: 'PAYMENT_GATEWAY',
          parameters: {
            gateway: 'pinpayments',
            gatewayMerchantId: process.env.VUE_APP_GOOGLE_PAY_MERCHANT,
          }
        }
      },
      checkoutTotalDiscount: {
        discountVoucher: {
          error: '',
          code: '',
          redeemed: false
        }
      },
      regoDiscounts: [
        {
          _id: Math.floor(100000 + Math.random() * 900000),
          discountVoucher: {
            error: '',
            code: '',
            redeemed: false
          },
          productIds: [],
        }
      ],
      totalDiscount: 0,
      productsDialogVisible: false,
      productsForDiscount: [],
      selectedRegos: [],
      limit: 0,
      discountId: undefined,
      availableProducts: [],
    };
  },
  mounted() {
    this.isLoaded = false;
    // set the Discount from store
    if (this.currentDiscounts && this.currentDiscounts.length) this.regoDiscounts = _.cloneDeep(this.currentDiscounts);

    // redirect to finder if cart is empty
    const pathName = this.hasCustomEntity ? 'custom-finder' : 'finder';
    if (this.$store.getters['cart/counts'] === 0) this.$router.push({ name: pathName });
    console.log(this.payment.registrations, '-----');
    this.isLoaded = true;
    if (this.isNewProduct) this.clearDiscounts();
  },
  methods: {
    updatePayLater(rego, idx) {
      this.$set(this.summary, idx, {
        ...rego,
        payLater: !rego.payLater
      });
      _.assign(this.payment.registrations[idx], {
        payLater: !this.payment.registrations[idx].payLater
      });
      this.$forceUpdate();
    },
    startApplePaySession() {
      if (!this.canShowApplePay) return this.$message.error('Apple Pay is not supported on this browser');
      const paymentRequest = this.applePayOptions;
      const session = new window.ApplePaySession(10, paymentRequest);
      console.log(session);

      session.onvalidatemerchant = (event) => {
        console.log('merchant is validated');
        const merchantSessionUrl = '/assemble/api/v1/portal/apple-pay/session';

        this.$http.post(merchantSessionUrl, {
          initiative_context: window.location.hostname,
          validation_url: event.validationURL,
        }).then((res) => {
          console.log({ session: res.data.session });
          session.completeMerchantValidation(res.data.session);
          console.log('completedMerchantValidation');
        })
          .catch((error) => {
            console.error('Error during merchant validation:', error);
          });
      };

      session.oncancel = () => {
        console.log('User canceled the payment session');
      };

      session.onpaymentauthorized = async (event) => {
        console.log('payment is authorized');
        const paymentToken = event.payment.token.paymentData;
        const data = {
          publishable_api_key: process.env.VUE_APP_PIN_PK,
          type: 'applepay',
          source: paymentToken,
        };
        const res = await this.$http.post('/assemble/api/v1/portal/apple-pay/token', data);
        if (!res.data.data || !res.data.data) this.$message.error('There has been an error, try again later.');
        const { token } = res.data.data.source;
        if (!token) {
          this.$store.commit('loading', false);
          this.$message.error('There has been an error, try again later.');
        }
        try {
          await this.register(token, 'apple');
          session.completePayment(window.ApplePaySession.STATUS_SUCCESS);
        } catch (error) {
          session.completePayment(window.ApplePaySession.STATUS_FAILURE);
        }
      };

      session.begin();
      return true;
    },
    async payGoogle(event) {
      if (!_.get(event, 'paymentMethodData.tokenizationData.token')) {
        this.$message.error('An error occurred');
      }
      this.$store.commit('loading', true);
      const data = {
        publishable_api_key: process.env.VUE_APP_PIN_PK,
        type: 'googlepay',
        source: JSON.parse(event.paymentMethodData.tokenizationData.token),
      };
      const res = await this.$http.post('/assemble/api/v1/portal/google-pay/token', data);
      if (!res.data.data || !res.data.data) this.$message.error('There has been an error, try again later.');
      const { token } = res.data.data.source;
      if (!token) {
        this.$store.commit('loading', false);
        this.$message.error('There has been an error, try again later.');
      }
      // register with card token
      this.register(token, 'google');
      // this.$store.commit('loading', true);
    },
    handleCancel() {
      console.log('here');
    },
    getFamilyMemberDetails(r) {
      const memberDetails = _.map((r.familyRegistrations), (rego) => ({
        playerName: `${rego.profile.firstName} ${rego.profile.lastName}`,
        age: calculateMemberAge(rego.profile.dob, this.endOfYear),
        memberType: rego.memberType,
      }));

      return memberDetails;
    },
    getFamilyMemberIds(r) {
      const memberIds = _.map((r.familyRegistrations), (rego) => rego.memberId);
      return _.join(_.map(memberIds, String), '');
    },
    clearDiscounts() {
      this.$store.commit('cart/clearDiscounts');

      if (_.isObject(this.regoDiscounts)) {
        this.regoDiscounts = [{
          _id: Math.floor(100000 + Math.random() * 900000),
          discountVoucher: {
            error: '',
            code: '',
            redeemed: false
          },
          productIds: [],
        }];
      }

      for (let index = 0; index <= this.payment.registrations.length - 1; index++) {
        const rego = this.payment.registrations[index];

        rego.discountVoucher = [];

        // Update cart store
        this.$store.commit('cart/update', {
          index,
          registration: rego
        });
      }

      this.$store.commit('cart/updateRegoDiscounts', {
        _id: Math.floor(100000 + Math.random() * 900000),
        discountVoucher: {
          error: '',
          code: '',
          redeemed: false
        },
        productIds: [],
      });
    },
    removeAdditionalVoucher(id) {
      const newRegoDiscounts = _.filter(this.regoDiscounts, (rego) => rego._id !== id);
      this.regoDiscounts = newRegoDiscounts;
      this.$store.commit('cart/updateRegoDiscounts', this.regoDiscounts);
    },
    newDiscountVoucher() {
      this.regoDiscounts.push({
        _id: Math.floor(100000 + Math.random() * 900000),
        discountVoucher: {
          error: '',
          code: '',
          redeemed: false
        },
        productIds: [],
      });
      this.$store.commit('cart/updateRegoDiscounts', this.regoDiscounts);
    },
    cancelRedeemedNew(discount) {
      for (let index = 0; index <= this.payment.registrations.length - 1; index++) {
        const rego = this.payment.registrations[index];

        const voucher = _.filter(rego.discountVoucher, (v) => v.code !== discount.code);
        rego.discountVoucher = voucher;

        // Update cart store
        this.$store.commit('cart/update', {
          index,
          registration: rego
        });
      }
      this.regoDiscounts[discount.index].discountVoucher = initDiscountCode();
      this.$store.commit('cart/updateRegoDiscounts', this.regoDiscounts);
    },
    async initRedeem(id) {
      const discountIndex = _.findIndex(this.regoDiscounts, (discount) => discount._id === id);

      const { code } = this.regoDiscounts[discountIndex].discountVoucher;

      if (!code) return;

      const count = _.countBy(this.codesInUsed);
      if (count[code] > 1 && this.codesInUsed.includes(code)) {
        this.regoDiscounts[discountIndex].discountVoucher.error = 'Code already used.';
        return;
      }

      await this.discountCodeCheck(discountIndex, code);
    },
    async applyDiscountToTotal(discountIndex, discount) {
      const {
        _id, type, name, amount, description, code, campaignDiscountType
      } = discount;

      if (discount) {
        const productTotal = this.total;

        let redeemedAmount = type === 'dollar' ? amount : ((amount * productTotal) / 100);
        if (redeemedAmount > productTotal) redeemedAmount = productTotal;
        const discountVoucher = {
          _id,
          code,
          name,
          description,
          type,
          balance: amount,
          redeemedAmount,
          redeemed: true,
          index: discountIndex,
          voucherType: campaignDiscountType,
        };
        this.regoDiscounts[discountIndex].discountVoucher = discountVoucher;
        this.regoDiscounts[discountIndex].type = campaignDiscountType;
        this.regoDiscounts[discountIndex].discountVoucher.error = '';
        this.$store.commit('cart/updateRegoDiscounts', this.regoDiscounts);
      }

      return false;
    },
    async applyDiscountToEntity(discountIndex) {
      const { code } = this.regoDiscounts[discountIndex].discountVoucher;
      const redeemed = [];
      for (let index = 0; index <= this.summary.length - 1; index++) {
        try {
          const rego = this.payment.registrations[index];
          const summary = this.summary[index];

          if (!rego.discountVoucher) {
            rego.discountVoucher = [];
          }

          rego.discountVoucher.error = '';

          // eslint-disable-next-line no-await-in-loop
          const res = await this.$http.post('assemble/api/v1/portal/discount-codes/redeem', {
            code,
            entityType: rego.entityType,
            entityId: rego.entityId
          });

          const {
            _id, limit, totalLimit, campaignDiscountType,
            type, name, amount, description, saleableItem
          } = res.data.data;

          // eslint-disable-next-line no-continue
          if (!_.get(res, 'data.data')) continue;

          // if (!_.get(res.data.data)) this.regoDiscounts[discountIndex].discountVoucher.error = 'Discount cannot be applied to this event / membership, please contact your administrator';

          if (_.get(rego, 'product._id') && _id && this.regoDiscounts[discountIndex] && !this.regoDiscounts[discountIndex].productIds.includes(_id)) this.regoDiscounts[discountIndex].productIds.push(_.get(rego, 'product._id'));

          // validate limitation
          const noOfUsed = _.sumBy(_.map(this.payment.registrations, 'discountVoucher'), (d) => d && d._id === _id);
          if (noOfUsed && noOfUsed + limit >= totalLimit) {
            summary.discountVoucher.error = 'Discount code already exceeds limit';
            // eslint-disable-next-line no-continue
            continue;
          }

          let productTotal;
          if (campaignDiscountType === 'saleable') {
            const foundItemIndex = _.findIndex(rego.saleableItems, (s) => s._id === saleableItem);
            productTotal = this.getTotalWithTransactionFee(_.get(rego, `saleableItems[${foundItemIndex}].price`, 0) * _.get(rego, `saleableItems[${foundItemIndex}].qty`, 0));
          } else if (campaignDiscountType === 'registration') {
            const products = _.filter(summary.products, (p) => p.voucherType !== 'saleable' && !p.isSaleableItem);
            productTotal = Math.abs(_.sumBy(products, 'total'));
          } else {
            productTotal = _.sumBy(summary.products, 'total');
          }

          let redeemedAmount = type === 'dollar' ? amount : ((amount * productTotal) / 100);
          if (redeemedAmount > productTotal) redeemedAmount = productTotal;
          const discountVoucher = {
            _id,
            code,
            name,
            description,
            type,
            balance: amount,
            redeemedAmount,
            redeemed: true,
            index: discountIndex,
            voucherType: campaignDiscountType,
          };

          if (productTotal > 0)rego.discountVoucher.push(discountVoucher);
          // Update cart store
          this.$store.commit('cart/update', {
            index,
            registration: rego
          });

          this.regoDiscounts[discountIndex].type = campaignDiscountType;
          this.regoDiscounts[discountIndex].discountVoucher = discountVoucher;
          this.regoDiscounts[discountIndex].regoIndex = index;
          redeemed.push(true);
        } catch (err) {
          console.log(err);
        }
      }

      if (!redeemed.includes(true)) this.regoDiscounts[discountIndex].discountVoucher.error = 'Invalid Code';

      this.$store.commit('cart/updateRegoDiscounts', this.regoDiscounts);
    },
    async applyDiscountToSelectedEntity() {
      const discountIndex = _.findIndex(this.regoDiscounts, (discount) => discount._id === this.discountId);
      const { code } = this.regoDiscounts[discountIndex].discountVoucher;

      for (let index = 0; index <= this.selectedRegos.length - 1; index++) {
        try {
          const i = _.findIndex(this.summary, (summary) => summary._id === this.selectedRegos[index]);
          const rego = this.payment.registrations[i];
          const summary = this.summary[i];
          if (!rego.discountVoucher) {
            rego.discountVoucher = [];
          }

          rego.discountVoucher.error = '';

          // eslint-disable-next-line no-await-in-loop
          const res = await this.$http.post('assemble/api/v1/portal/discount-codes/redeem', {
            code,
            entityType: rego.entityType,
            entityId: rego.entityId
          });

          const {
            _id, limit, totalLimit, campaignDiscountType,
            type, name, amount, description, saleableItem
          } = res.data.data;

          if (!_.get(res.data.data)) {
            // this.regoDiscounts[discountIndex].discountVoucher.error = 'Discount cannot be applied to this event / membership, please contact your administrator';
            this.productsDialogVisible = false;
          }

          if (_.get(rego, 'product._id') && _id && this.regoDiscounts[discountIndex] && !this.regoDiscounts[discountIndex].productIds.includes(_id)) this.regoDiscounts[discountIndex].productIds.push(_.get(rego, 'product._id'));

          // validate limitation
          const noOfUsed = _.sumBy(_.map(this.payment.registrations, 'discountVoucher'), (d) => d && d._id === _id);
          if (noOfUsed && noOfUsed + limit >= totalLimit) {
            summary.discountVoucher.error = 'Discount code already exceeds limit';
            return;
          }

          let productTotal;
          if (campaignDiscountType === 'saleable') {
            const foundItemIndex = _.findIndex(rego.saleableItems, (s) => s._id === saleableItem);
            productTotal = this.getTotalWithTransactionFee(rego.saleableItems[foundItemIndex].price) * rego.saleableItems[foundItemIndex].qty;
          } else if (campaignDiscountType === 'registration') {
            const products = _.filter(summary.products, (p) => p.voucherType !== 'saleable' && !p.isSaleableItem);
            productTotal = Math.abs(_.sumBy(products, 'total'));
          } else {
            productTotal = _.sumBy(summary.products, 'total');
          }

          let redeemedAmount = type === 'dollar' ? amount : ((amount * productTotal) / 100);
          if (redeemedAmount > productTotal) redeemedAmount = productTotal;
          const discountVoucher = {
            _id,
            code,
            name,
            description,
            type,
            balance: amount,
            redeemedAmount,
            redeemed: true,
            index: discountIndex,
            voucherType: campaignDiscountType,
          };

          rego.discountVoucher.push(discountVoucher);
          // Update cart store
          this.$store.commit('cart/update', {
            index: i,
            registration: rego
          });

          this.regoDiscounts[discountIndex].type = campaignDiscountType;
          this.regoDiscounts[discountIndex].discountVoucher = discountVoucher;
        } catch (err) {
          console.log(err);
        }
      }

      this.$store.commit('cart/updateRegoDiscounts', this.regoDiscounts);
      this.availableProducts = [];
      this.selectedRegos = [];
      this.productsDialogVisible = false;
    },
    isQtyDisabled(product) {
      if (product.isSaleableItem) return false;
      if (product.isSaleableItem !== undefined && product.isSaleableItem === false) return true;
      if (product.feeRequired !== undefined && product.feeRequired === false) return false;

      return true;
    },
    updateCstmFeeQty(index, product) {
      const rego = this.payment.registrations[index];
      const regoSummary = this.summary[index];

      rego.product.customFees.qty = product.qty;
      rego.product.customFees.total = product.qty * product.price;
      // Update cart store
      this.$store.commit('cart/update', {
        index,
        registration: rego
      });
      _.forEach(regoSummary.products, (p) => {
        if (p.isCustomFees) {
          // eslint-disable-next-line no-param-reassign
          p.qty = product.qty;
          // eslint-disable-next-line no-param-reassign
          p.total = product.qty * product.price;
        }
      });

      this.$message.success('Successfully updated');
    },
    checkMaxQty(rego) {
      if (
        rego.multiplePurchaseEnable
          || rego.multiplePurchaseEnable === undefined
      ) {
        return Infinity;
      }
      return 1;
    },
    getTotalWithTransactionFee(total) {
      // If a national has product transaction fee setting, apply it to product
      const preference = this.$store.getters['national/paymentPreference'];
      const { addToProduct } = preference;
      if (!addToProduct) return total;
      return +(total * ((100 + addToProduct) / 100)).toFixed();
    },
    cancelRedeemed(index) {
      const rego = this.payment.registrations[index];

      rego.discountVoucher = [];

      // Update cart store
      this.$store.commit('cart/update', {
        index,
        registration: rego
      });
    },
    async redeem(index) {
      const rego = this.payment.registrations[index];
      const summary = this.summary[index];

      if (!rego.discountVoucher) {
        rego.discountVoucher = [];
      }

      rego.discountVoucher.error = '';

      this.$http.post('assemble/api/v1/portal/discount-codes/redeem', {
        code: summary.discountVoucher.code,
        entityType: rego.entityType,
        entityId: rego.entityId
      }).then((res) => {
        const {
          _id, limit, totalLimit, code,
          type, name, amount, description, isSaleableItem, saleableItem, isRegistration
        } = res.data.data;

        // validate limitation
        const noOfUsed = _.sumBy(_.map(this.payment.registrations, 'discountVoucher'), (d) => d && d._id === _id);
        if (noOfUsed && noOfUsed + limit >= totalLimit) {
          summary.discountVoucher.error = 'Discount code already exceeds limit';
          return;
        }

        let productTotal;
        if (isSaleableItem) {
          const foundItemIndex = _.findIndex(rego.saleableItems, (s) => s._id === saleableItem);
          productTotal = this.getTotalWithTransactionFee(rego.saleableItems[foundItemIndex].price) * rego.saleableItems[foundItemIndex].qty;
        } else if (isRegistration) {
          const saleableItemTotal = _.sumBy(rego.saleableItems, (item) => this.getTotalWithTransactionFee(item.price) * item.qty);
          productTotal = Math.abs(_.sumBy(summary.products, 'total') - saleableItemTotal);
        } else {
          productTotal = _.sumBy(summary.products, 'total');
        }

        let redeemedAmount = type === 'dollar' ? amount : ((amount * productTotal) / 100);
        redeemedAmount = +redeemedAmount.toFixed();
        if (redeemedAmount > productTotal) redeemedAmount = productTotal;
        rego.discountVoucher = {
          _id,
          code,
          name,
          description,
          type,
          balance: amount,
          redeemedAmount,
          redeemed: true
        };
        // Update cart store
        this.$store.commit('cart/update', {
          index,
          registration: rego
        });
      }).catch((err) => {
        console.log('err', err);
        summary.discountVoucher.error = 'Discount cannot be applied to this event / membership, please contact your administrator';
      });
    },
    searchCountry(query, cb) {
      if (query && query !== '') {
        setTimeout(() => {
          cb(this.countries.filter((item) => item.label.toLowerCase()
            .indexOf(query.toLowerCase()) > -1));
        }, 200);
      } else {
        cb([]);
      }
    },

    remove(index, type) {
      const text = type === 'family' ? 'When removing this option all selected members will be removed and would need to be added again.' : 'Are you sure you want to remove this registration?';
      this.$confirm(text, 'Confirm', {
        distinguishCancelAndClose: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
      }).then(() => {
        const rego = this.payment.registrations[index];
        const cartRegos = this.$store.getters['cart/registrations'];
        // find the cart rego that has the same product id and matched member ids
        const cartRegoIndex = cartRegos.findIndex((r) => r.product._id === rego.product._id && _.isEqual(r.memberIds, rego.memberIds));
        if (cartRegoIndex !== -1) {
          this.$store.commit('cart/remove', cartRegoIndex);
        }
        this.payment.registrations.splice(index, 1);
        this.summary.splice(index, 1);

        // Redirect to finder if no registration
        const pathName = this.hasCustomEntity ? 'custom-finder' : 'finder';
        if (this.payment.registrations.length === 0) this.$router.push({ name: pathName });
      });
    },
    edit(index) {
      const registration = _.cloneDeep(this.payment.registrations[index]);
      const { memberId } = registration;
      console.log(registration, 'regisration');
      if (registration.entityType === 'event') {
        if (registration.productType === 'indv') {
          const pathName = this.hasCustomEntity ? 'custom-event-register-individual' : 'event-register-individual';
          this.$router.push({ name: pathName, params: { editingRego: registration, memberId, editing: true } });
        } else if (registration.productType === 'indv-to-team') {
          const pathName = this.hasCustomEntity ? 'custom-event-register-individual-to-team' : 'event-register-individual-to-team';
          this.$router.push({ name: pathName, params: { editingRego: registration, memberId, editing: true } });
        }
      } else if (registration.entityType === 'membership') {
        const pathName = this.hasCustomEntity ? 'custom-membership-register-individual' : 'membership-register-individual';
        this.$router.push({ name: pathName, params: { editingRego: registration, memberId, editing: true } });
      }
    },

    fillAddress(address) {
      _.assign(this.payment.billingAddress, address);

      // this.payment.billingAddress = {
      //   formatted: address.formatted,
      //   addressLine1: address.addressLine1,
      //   addressLine2: address.addressLine2,
      //   suburb: address.suburb,
      //   state: address.state,
      //   postcode: address.postcode,
      //   country: address.country,
      // };
    },
    showActiveKidsModal(index) {
      this.activeKids.regoIndex = index;
      this.activeKids.pin = this.summary[index].voucherPin;
      this.activeKidsModalVisible = true;
    },
    showAdditionalActiveKidsModal(index) {
      this.additionalActiveKids.regoIndex = index;
      this.additionalActiveKids.pin = this.summary[index].voucherPin;
      this.additionalActiveKidsModalVisible = true;
    },
    showVICActiveKidsModal(index) {
      this.victoriaActiveKids.regoIndex = index;
      this.victoriaActiveKids.voucherNumber = '';
      this.victoriaActiveKidsVisible = true;
    },
    handleActiveKidsClose(done) {
      this.activeKids = initActiveKids();
      done();
    },
    handleVictoriaActiveKidsClode(done) {
      this.victoriaActiveKids = initVictoriaActiveKids();
      done();
    },
    addActiveKidsVoucher() {
      const { regoIndex: index, voucherNumber, pin } = this.activeKids;
      this.$refs.activeKids.validate((valid) => {
        if (valid) {
          const foundBarcode = _.find(this.payment.registrations, (r) => r.activeKidsVoucher && r.activeKidsVoucher.barcode === this.activeKids.voucherNumber);
          if (foundBarcode) return this.$message.error('Voucher code has already been applied.');

          this.$store.commit('loading', { loading: true, text: 'Loading...' });
          this.$http.post('/assemble/api/v1/portal/registrations/nsw-voucher', {
            barcode: this.activeKids.voucherNumber,
            pin: this.activeKids.pin
          }).then((res) => {
            const balanceInDollar = res.data.data;
            const balance = balanceInDollar * 100;
            const rego = this.payment.registrations[index];
            const regoSummary = this.summary[index];
            const eligibleTotal = regoSummary.products
              .filter((p) => !p.isSaleableItem)
              .reduce((acc, product) => acc + product.total, 0);

            const redeemedAmount = Math.min(eligibleTotal, balance);

            // Add to registrations
            rego.activeKidsVoucher = {
              barcode: voucherNumber,
              pin,
              balance,
              redeemedAmount
            };

            // Update summary
            regoSummary.products.push({
              name: 'Active Kids Voucher',
              description: '',
              qty: 1,
              total: -redeemedAmount,
              price: -redeemedAmount,
              isVoucher: true
            });

            // Update cart store
            this.$store.commit('cart/update', {
              index,
              registration: rego
            });

            this.activeKids = initActiveKids();
            this.activeKidsModalVisible = false;

            this.$store.commit('loading', false);
          }).catch((e) => {
            this.$message.error(e.response.data.message);
            this.$store.commit('loading', false);
          });
        }
        return true;
      });
    },
    addAdditionalActiveKidsVoucher() {
      const { regoIndex: index, voucherNumber, pin } = this.additionalActiveKids;
      this.$refs.additionalActiveKids.validate((valid) => {
        if (valid) {
          const isSameAsActiveKids = this.payment.registrations[index].activeKidsVoucher.barcode === this.additionalActiveKids.voucherNumber;
          if (isSameAsActiveKids) return this.$message.error('Voucher code has already been applied.');

          const foundBarcode = _.find(this.payment.registrations, (r) => r.additionalActiveKidsVoucher && r.additionalActiveKidsVoucher.barcode === this.additionalActiveKids.voucherNumber);
          if (foundBarcode) return this.$message.error('Voucher code has already been applied.');

          this.$store.commit('loading', { loading: true, text: 'Loading...' });
          this.$http.post('/assemble/api/v1/portal/registrations/nsw-voucher', {
            barcode: this.additionalActiveKids.voucherNumber,
            pin: this.additionalActiveKids.pin
          }).then((res) => {
            const balanceInDollar = res.data.data;
            const balance = balanceInDollar * 100;
            const rego = this.payment.registrations[index];
            const regoSummary = this.summary[index];
            const eligibleTotal = regoSummary.products
              .filter((p) => !p.isSaleableItem)
              .reduce((acc, product) => acc + product.total, 0);

            console.log({ eligibleTotal });

            // if (rego.activeKidsVoucher && rego.activeKidsVoucher.redeemedAmount) {
            //   eligibleTotal -= rego.activeKidsVoucher.redeemedAmount;

            //   console.log({ regoActiveKidsAmount: rego.activeKidsVoucher.redeemedAmount });
            // }
            // console.log({ eligibleTotal });

            if (eligibleTotal <= 0) {
              this.$message.error('All eligible costs have been covered by the previous voucher. No additional discount can be applied.');
              this.$store.commit('loading', false);
              return;
            }

            const redeemedAmount = Math.min(eligibleTotal, balance);

            rego.additionalActiveKidsVoucher = {
              barcode: voucherNumber,
              pin,
              balance,
              redeemedAmount
            };

            regoSummary.products.push({
              name: 'Additional Active Kids Voucher',
              description: '',
              qty: 1,
              total: -redeemedAmount,
              price: -redeemedAmount,
              isVoucher: true
            });

            this.$store.commit('cart/update', {
              index,
              registration: rego
            });

            this.additionalActiveKids = initActiveKids(); // Assuming you have a similar method to reset the form
            this.additionalActiveKidsModalVisible = false; // Assuming you manage visibility similarly

            this.$store.commit('loading', false);
          }).catch((e) => {
            this.$message.error(e.response.data.message);
            this.$store.commit('loading', false);
          });
        }
        return true;
      });
    },
    addVICActiveKidsVoucher() {
      const { regoIndex: index, voucherNumber } = this.victoriaActiveKids;
      this.$refs.victoriaActiveKids.validate((valid) => {
        if (valid) {
          const foundBarcode = _.find(this.payment.registrations, (r) => r.victoriaActiveKids && r.victoriaActiveKids.voucherNumber === voucherNumber);
          if (foundBarcode) return this.$message.error('Voucher code has already been applied.');

          // Format: G5-1234567-EW64 (G5 = Group, 1234567 = Provider Number, EW64 = Pin)
          // Check if voucher number matches format (uppercase, length)
          const regex = /^[A-Z0-9]{2}-[0-9]{7}-[A-Z0-9]{4}$/;
          if (!regex.test(voucherNumber)) return this.$message.error('Voucher number is invalid.');

          const balance = 20000;
          const rego = this.payment.registrations[index];
          const regoSummary = this.summary[index];
          const registrationFeeTotal = (regoSummary.products || [])
            .find((p) => p.name === 'Registration Fee')
            .total;
          const redeemedAmount = registrationFeeTotal >= balance ? balance : regoSummary.total;

          // Add to registrations
          rego.activeKidsVoucher = {
            barcode: voucherNumber,
            pin: '0000',
            balance: 0,
            redeemedAmount,
            price: -redeemedAmount
          };

          // Update summary
          this.summary[index].products.push({
            name: 'Active Kids VIC',
            description: '',
            qty: 1,
            total: -redeemedAmount,
            price: -redeemedAmount,
            isVoucher: true
          });

          // Update cart store
          this.$store.commit('cart/update', {
            index,
            registration: rego
          });

          this.victoriaActiveKids = initVictoriaActiveKids();
          this.victoriaActiveKidsVisible = false;

          this.$store.commit('loading', false);
        }
        return true;
      });
    },
    deleteVoucher(index) {
      const rego = this.payment.registrations[index];
      delete rego.activeKidsVoucher;

      // Update cart store
      this.$store.commit('cart/update', {
        index,
        registration: rego
      });

      const regoSummary = this.summary[index];
      const voucherIndex = _.findIndex(regoSummary.products, (p) => p.isVoucher === true);
      regoSummary.products.splice(voucherIndex, 1);
    },
    deleteSaleableItem(index, item, itemIndex) {
      this.$confirm('Are you sure you want to remove this item?', 'Confirm', {
        distinguishCancelAndClose: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
      }).then(() => {
        const rego = this.payment.registrations[index];
        const foundItemIndex = _.findIndex(rego.saleableItems, (i) => i._id === item._id);
        if (foundItemIndex > -1) {
          if (rego.saleableItems[foundItemIndex].required) {
            this.$message.error('You must have at least one item for this registration.');
          } else {
            rego.saleableItems.splice(foundItemIndex, 1);
            // Update cart store
            this.$store.commit('cart/update', {
              index,
              registration: rego
            });
            const regoSummary = this.summary[index];
            regoSummary.products.splice(itemIndex, 1);
          }
        }
      }).catch((err) => {
        console.log(err);
      });

      // const product
    },
    deleteDirectSaleableItem(item, idx) {
      this.$confirm('Are you sure you want to remove this item?', 'Confirm', {
        distinguishCancelAndClose: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
      }).then(() => {
        this.payment.directSaleableItems.splice(idx, 1);
        // Update cart store
        this.$store.commit('cart/updateDirectStoreItems', {
          saleableItems: this.payment.directSaleableItems
        });
      }).catch((err) => {
        console.log(err);
      });
    },
    updateDirectQty(item, idx) {
      this.payment.directSaleableItems[idx].qty = item.qty;
      // Update cart store
      this.$store.commit('cart/updateDirectStoreItems', {
        saleableItems: this.payment.directSaleableItems
      });
    },

    updateQty(index, item) {
      const rego = this.payment.registrations[index];
      // const product
      // find saleable item
      const foundItemIndex = _.findIndex(rego.saleableItems, (i) => i._id === item._id);
      const regoSummary = this.summary[index];
      const foundSummaryItem = _.findIndex(regoSummary.products, (i) => i._id === item._id);
      if (foundItemIndex > -1) {
        if (rego.saleableItems[foundItemIndex].required && (!item.qty || item.qty === 0)) {
          this.$message.error('You must have at least one item for this registration.');
          rego.saleableItems[foundItemIndex].qty = 1;
          regoSummary.products[foundSummaryItem].qty = 1;
        } else {
          rego.saleableItems[foundItemIndex].qty = item.qty;
          // update cart store
          this.$store.commit('cart/update', {
            index,
            registration: rego
          });
          if (foundSummaryItem > -1) {
            regoSummary.products[foundSummaryItem].qty = item.qty;
            // update total
            regoSummary.products[foundSummaryItem].total = item.qty * rego.saleableItems[foundItemIndex].price;
          }
        }

        // update summary
      }
    },
    noQtyChanged(index, item, itemIndex) {
      const summaryItem = this.originalSummary[index].products[itemIndex];
      return item.qty === summaryItem.qty;
    },
    voucherAvailable(rego) {
      console.log('voucherAvailable', rego);
      // Don't show for FENCING NSW
      if (this.nationalId === 10) return false;
      if (this.nationalId === 1 && rego.entityLevel === 'club') return false;
      return (!_.find(rego.products, (p) => p.isVoucher === true) && rego.acceptActiveKids && rego.age <= 19);
    },
    additionalVoucherAvailable(rego, index) {
      if (this.nationalId === 10) return false;
      if (this.nationalId === 1 && rego.entityLevel === 'club') return false;
      const r = this.payment.registrations[index];
      if (r.additionalActiveKidsVoucher && r.additionalActiveKidsVoucher.barcode) return false;
      return (_.find(rego.products, (p) => p.isVoucher === true) && rego.acceptActiveKids && rego.age <= 19);
    },
    manualAddress() {
      this.payment.billingAddress.isManual = !this.payment.billingAddress.isManual;
    },
    getTransactionFee(money) {
      const percent = this.$store.getters['cart/transactionFee'];
      const preference = this.$store.getters['national/paymentPreference'];
      let fee = 0;
      if (preference.addToTotal >= 0) {
        fee = +((money * preference.addToTotal) / 100).toFixed();
      } else if (!(preference.addToProduct >= 0)) {
        // Only use default total if no product or total setting
        fee = +((money * percent) / 100).toFixed();
      }
      return fee;
    },
    register(token, paymentMethod = 'default') {
      if (this.requirePayment && !token) return;
      this.checkCustomFees();
      if (this.requirePayment && !token) return;
      this.$store.commit('cart/clearConfirmation');
      // get the payToday for each registration

      this.$http.post('assemble/api/v1/portal/registrations/register', {
        registrations: this.payment.registrations,
        cardToken: token,
        paymentTotal: this.payAfter ? this.payTodayTotal : this.total,
        payToday: this.cartTotal,
        paymentInstallment: this.payAfter ? this.cartTotal : this.total,
        paymentMethod,
      }).then(() => {
        this.$message.success('Successfully registered.');
        this.$store.commit('cart/successful');
        this.$store.commit('cart/clear');
        const pathName = this.hasCustomEntity ? 'custom-success' : 'success';
        this.$router.push({ name: pathName });
        this.$store.commit('loading', false);
      }).catch((err) => {
        const serverError = _.get(err, 'response.data.message');
        this.$store.commit('loading', false);
        this.$message.error(serverError || 'There has been an error');
        // if (googleToken) throw new Error(serverError || 'There has been an error');
      });

      // async register(token) {
      //   this.checkCustomFees();
      //   // if (this.requirePayment && !token) return;
      //   if (this.payment.registrations.length >= 1) {
      //     // eslint-disable-next-line no-restricted-syntax
      //     for (const [index, event] of this.payment.registrations.entries()) {
      //       console.log('test', event);
      //       if (_.get(event, 'product.customFees.isFixedValue') === false && _.get(event, 'product.customFees.value') === 0) {
      //         try {
      //           // eslint-disable-next-line no-await-in-loop
      //           await this.$confirm(`Would you like to contribute for ${_.get(event, 'product.name', '') !== '' ? event.product.name : event.entityName}`, `${event.product.customFees.label}`, {
      //             confirmButtonText: 'Yes',
      //             cancelButtonText: 'No',
      //             type: 'warning'
      //           });

      //           // if yes pop up another dialog to ask how much they want to donate
      //           // eslint-disable-next-line no-await-in-loop
      //           const donationResponse = await this.$prompt('Please enter the amount you would like to contribute', `${event.product.customFees.label}`, {
      //             confirmButtonText: 'Confirm',
      //             cancelButtonText: 'Cancel',
      //             inputPattern: /\d+/,
      //             inputErrorMessage: 'Please enter a valid number'
      //           });

      //           // eslint-disable-next-line no-param-reassign
      //           event.product.customFees.value = parseInt(donationResponse.value) * 100;
      //           // update the payment regisration
      //           this.payment.registrations[index] = event;
      //           // update the summary
      //           this.summary[index].products.push({
      //             name: event.product.customFees.label,
      //             description: '',
      //             qty: 1,
      //             total: event.product.customFees.value,
      //             price: event.product.customFees.value,
      //             isCustomFees: true
      //           });
      //           // update the this.total
      //           this.total += event.product.customFees.value;
      //         } catch (err) {
      //           console.log(err);
      //         }
      //       }

      // Only execute the post request after the last donation confirmation
      //       if (index === this.payment.registrations.length - 1) {
      //         this.executeRegistations(token);
      //         console.log('this.summary', this.payment.registrations);
      //       }
      //     }
      //   } else {
      //     // this.executeRegistations(token);
      //   }
      // },
    },
    setPayToday() {
      const { registrations } = this.payment;

      _.forEach((this.summary), (summary) => {
        const index = _.findIndex(registrations, (registration) => _.get(registration, 'product._id') === summary.productId && _.get(registration, 'memberId') === summary.memberId);

        if (index >= 0) {
          if (summary.payToday) registrations[index].payToday = summary.payToday;
          else registrations[index].payToday = _.get(registrations[index], 'product.price');
        }
      });
    },
    //       // Only execute the post request after the last donation confirmation
    //       if (index === this.payment.registrations.length - 1) {
    //         this.executeRegistations(token);
    //         console.log('this.summary', this.payment.registrations);
    //       }
    //     }
    //   } else {
    //     // this.executeRegistations(token);
    //   }
    // },
    transformFamilyToIndvRegistration() {
      const formattedRegistrations = [];
      _.forEach((this.payment.registrations), (r) => {
        if (r.productType === 'family') {
          _.forEach((r.familyRegistrations), (rego, index) => {
            // eslint-disable-next-line no-param-reassign
            rego.product.price = index === 0 ? r.product.price : 0;
            const obj = {
              ...r,
              ...rego,
              memberId: rego.memberId,
              memberType: rego.memberType,
              productId: rego.productId,
              profile: rego.profile,
            };
            formattedRegistrations.push(obj);
          });
        } else {
          formattedRegistrations.push(r);
        }
      });
      return formattedRegistrations;
    },

    executeRegistations(token) {
      console.log('token', token);
      console.log('this.summary', this.payment.registrations);
      this.setPayToday();
      console.log('this.payment.registrations', this.payment.registrations);
      this.$store.commit('cart/clearConfirmation');
      this.$http.post('assemble/api/v1/portal/registrations/register', {
        registrations: this.payment.registrations,
        cardToken: token,
        paymentTotal: this.payAfter ? this.payTodayTotal : this.total,
        payToday: this.cartTotal,
        paymentInstallment: this.payAfter ? this.cartTotal : this.total,
      }).then(() => {
        this.$message.success('Successfully registered.');
        this.$store.commit('cart/successful');
        this.$store.commit('cart/clear');
        const pathName = this.hasCustomEntity ? 'custom-success' : 'success';
        this.$router.push({ name: pathName });
        this.$store.commit('loading', false);
      }).catch((err) => {
        const serverError = _.get(err, 'response.data.message');
        this.$store.commit('loading', false);
        this.$message.error(serverError || 'There has been an error');
      });
    },
    // executeRegistations(token) {
    //   console.log('this.summary', this.payment.registrations);
    //   this.$store.commit('cart/clearConfirmation');
    //   this.$http.post('assemble/api/v1/portal/registrations/register', {
    //     registrations: this.payment.registrations,
    //     cardToken: token,
    //     paymentTotal: this.payAfter ? this.payTodayTotal : this.total,
    //     payToday: this.cartTotal,
    //     paymentInstallment: this.payAfter ? this.cartTotal : this.total,
    //   }).then(() => {
    //     this.$message.success('Successfully registered.');
    //     this.$store.commit('cart/successful');
    //     this.$store.commit('cart/clear');
    //     this.$router.push('/success');
    //     this.$store.commit('loading', false);
    //   }).catch((err) => {
    //     const serverError = _.get(err, 'response.data.message');
    //     this.$store.commit('loading', false);
    //     this.$message.error(serverError || 'There has been an error');
    //   });
    // },
    checkCustomFees() {
      _.forEach(this.payment.registrations, (rego) => {
        if (_.get(rego, 'product.customFees.qty') >= 0) {
          const newValue = _.get(rego, 'product.customFees.value') * _.get(rego, 'product.customFees.qty');
          // eslint-disable-next-line no-param-reassign
          rego.product.customFees.value = newValue;
        }
      });
    },

    pay() {
      // get 2 tokens from pin for registrations and direct saleable items
      this.setPayToday();
      Promise.all([this.$refs.card && this.$refs.card.validate(), this.$refs.form && this.$refs.form.validate()])
        .then(([cardValid, formValid]) => {
          console.log('form check');
          if (this.requirePayment && (!cardValid || !formValid)) return;
          console.log('proceed');

          // if payment is not required || payment total is 0
          if (!this.requirePayment) {
            // call register without card token
            // this.register();
            // call register without card token
            this.processingPayment = true;
            console.log('do not require payment');
            return;
          }
          // Update formatted for isManual
          if (this.payment.billingAddress.isManual) {
            this.payment.billingAddress.formatted = parstAddressFormatted(
              this.payment.billingAddress
            );
          }
          // issue card token
          const [expiryMonth, expiryYear] = this.payment.card.expiry.replace(/\s/g, '').split('/');

          // Create two token promises
          const tokenPromise1 = this.createToken(expiryMonth, expiryYear);
          const tokenPromise2 = this.createToken(expiryMonth, expiryYear);

          this.$store.commit('loading', { loading: true, text: 'Loading...' });
          Promise.all([tokenPromise1, tokenPromise2])
            .then(([token1, token2]) => {
              // Now you have two tokens: token1 and token2
              // You can use them for your registration or whatever you need
              this.token1 = token1;
              this.token2 = token2;
              if (this.requirePayment && !token1 && !token2) return;
              this.processingPayment = true;
              this.$store.commit('loading', false);
            })
            .catch((err) => {
              this.$store.commit('loading', false);
              let pinError = _.get(err, 'messages.0.message');
              const pinErrorCode = _.get(err, 'messages.0.code');
              if (pinErrorCode.includes('number') && pinErrorCode.includes('invalid')) {
                pinError = 'Card Number not supported';
              }
              this.$message.error(pinError || 'There has been an error');
            });
        }).catch(() => {});
    },
    createToken(expiryMonth, expiryYear) {
      console.log('creating');
      console.log('pin', this.pin);
      return this.pin.createCardToken({
        number: this.payment.card.number,
        name: this.payment.card.name,
        expiry_month: expiryMonth,
        expiry_year: expiryYear,
        cvc: this.payment.card.cvc,
        address_line1: this.payment.billingAddress.addressLine1,
        address_line2: this.payment.billingAddress.addressLine2 || '',
        address_city: this.payment.billingAddress.suburb,
        address_state: this.payment.billingAddress.state,
        address_postcode: this.payment.billingAddress.postcode,
        address_country: 'Australia',
      }).then((pinResponse) => {
        console.log('pinResponse', pinResponse);
        const { token, } = pinResponse;
        if (!token) {
          throw new Error('Token generation failed');
        }
        return token;
      }).catch((err) => {
        console.error('err', err);
        throw err;
      });
    },
    async discountCodeCheck(discountIndex, code) {
      try {
        const res = await this.$http.post('/assemble/api/v1/portal/discount-codes/redeem-check-point', { code });

        const discount = _.get(res, 'data.data.discount');
        if (!discount) {
          return false;
        }

        if (discount) this.productCheck(discountIndex, discount);
        this.discountId = _.get(this, `regoDiscounts[${discountIndex}]._id`);
        return res.data.data;
      } catch (error) {
        const message = _.get(error, 'response.data.message');
        this.regoDiscounts[discountIndex].discountVoucher.error = message;
      }

      return true;
    },
    productCheck(discountIndex, discount) {
      const { entityId, limit, totalLimit } = discount;
      const { registrations } = this.payment;

      const filterRego = _.filter(registrations, (rego) => _.includes(entityId, rego.entityId));
      if (limit >= totalLimit) {
        // eslint-disable-next-line no-param-reassign
        this.regoDiscounts[discountIndex].discountVoucher.error = 'Discount code already exceeds limit';
        return;
      }
      if (filterRego.length + limit > totalLimit) {
        this.limit = totalLimit - limit;
        this.availableProducts = filterRego;
        const objKeys = _.map(filterRego, (rego) => {
          if (rego.productType === 'family') {
            const memberIds = this.getFamilyMemberIds(rego);
            return { [`${memberIds}${_.get(rego, 'product._id')}`]: false };
          }
          return { [`${_.get(rego, 'memberId')}${_.get(rego, 'product._id')}`]: false };
        });
        this.productsForDiscount = objKeys;
        this.productsDialogVisible = true;
      } else if (discount && discount.campaignDiscountType === 'checkoutTotal') {
        if (limit === totalLimit) {
          this.regoDiscounts[discountIndex].discountVoucher.error = 'Discount code already exceeds limit';
          return;
        }
        this.applyDiscountToTotal(discountIndex, discount);
      } else this.applyDiscountToEntity(discountIndex);
    },
    regoSelected(val, rego) {
      const _id = rego.productType === 'family' ? `${this.getFamilyMemberIds(rego)}${rego.product._id}` : `${rego.memberId}${rego.product._id}`;
      if (val) {
        if (!_.includes(this.selectedRegos, _id)) this.selectedRegos.push(_id);
      } else {
        const removedId = _.filter(this.selectedRegos, (discount) => discount !== _id);
        this.selectedRegos = removedId;
      }
    },
    checkDiscountLimit(rego) {
      const id = rego.productType === 'family' ? `${this.getFamilyMemberIds(rego)}${rego.product._id}` : `${rego.memberId}${rego.product._id}`;
      return this.selectedProductCount >= this.limit && !this.selectedRegos.includes(id);
    },
    handleRegoSelectionClose() {
      this.selectedRegos = [];
      this.productsDialogVisible = false;
    },
    memberDetails(rego) {
      const selectedBulkMembers = this.$store.getters['cart/selectedBulkMembers'];
      const memberDetails = selectedBulkMembers.filter((member) => rego.memberIds.includes(member._id));
      console.log('memberDetails attat', memberDetails);
      return memberDetails;
    },
    removeMember(rego, memberId) {
      this.$confirm('Are you sure you want to remove this member?', 'Warning', {
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        type: 'warning'
      }).then(() => {
        const regoIndex = this.payment.registrations.findIndex((r) => r.product._id === rego.productId);
        if (regoIndex !== -1) {
          const memberIndex = this.payment.registrations[regoIndex].memberIds.findIndex((id) => id === memberId);
          if (memberIndex !== -1) {
            this.payment.registrations[regoIndex].memberIds.splice(memberIndex, 1);
            this.$store.commit('cart/updateRego', { regoIndex, memberId });
            this.$set(this.payment.registrations, regoIndex, { ...this.payment.registrations[regoIndex] }); // Ensure reactivity

            this.updateSummary(); // Ensure Vue reactivity updates the summary
            this.$forceUpdate();
          }
        }
      }).catch(() => {});
    },
    updateSummary() {
      this.summary = this.payment.registrations.map((r) => {
        console.log('memberIds', r.memberIds.length);
        const products = [
          {
            name: `${r.product.price > 0 ? 'Registration Fee' : 'Registration'}`,
            qty: r.memberIds.length,
            total: this.getTotalWithTransactionFee(r.product.price),
            price: r.product.price,
            subProducts: r.subProducts
          }
        ];
        // Add custom fees if rego has one
        if (r.product.customFees && r.product.customFees.value > 0) {
          const qty = r.product.customFees.qty || 1;
          products.push({
            name: r.product.customFees.label === '' ? 'Custom Fee' : r.product.customFees.label,
            qty,
            feeRequired: r.product.customFees.required === undefined ? true : r.product.customFees.required,
            isCustomFees: true,
            price: r.product.customFees.value,
            total: this.getTotalWithTransactionFee(r.product.customFees.value * qty),
          });
        }
        let productTotal = products.reduce((acc, p) => acc + p.total, 0);
        if (r.upgradeFromMembership) {
          let feePaid = r.upgradeFromMembership.pricing.membership.price;
          if (feePaid > productTotal) feePaid = productTotal;
          products.push({
            name: 'Membership Upgrade',
            description: `Upgrade from ${r.upgradeFromMembership.regoEntity.name}`,
            qty: 1,
            total: -feePaid,
          });
        }

        r.saleableItems.forEach((i) => {
          if (i.qty > 0) {
            products.push({
              name: i.name,
              description: i.description,
              isSaleableItem: true,
              price: i.price,
              _id: i._id,
              qty: i.qty,
              total: this.getTotalWithTransactionFee(i.price * i.qty),
            });
          }
        });

        productTotal = products.reduce((acc, p) => acc + p.total, 0);

        if (r.activeKidsVoucher) {
          products.push({
            name: 'Active Kids Voucher',
            description: '',
            qty: 1,
            total: -r.activeKidsVoucher.redeemedAmount,
            isVoucher: true
          });
        }

        if (r.additionalActiveKidsVoucher) {
          products.push({
            name: 'Additional Active Kids Voucher',
            description: '',
            qty: 1,
            total: -r.additionalActiveKidsVoucher.redeemedAmount,
            isVoucher: true
          });
        }

        r.discounts.forEach((i) => {
          let redeemedAmount = 0;
          if (i.isSaleableItem) {
            const foundItemIndex = r.saleableItems.findIndex((s) => s._id === i.saleableItem);
            if (foundItemIndex > -1) {
              let balanceAmount = this.getTotalWithTransactionFee(r.saleableItems[foundItemIndex].price) * r.saleableItems[foundItemIndex].qty;
              redeemedAmount = i.type === 'dollar' ? i.amount : ((i.amount * balanceAmount) / 100);
              if (redeemedAmount > balanceAmount) redeemedAmount = balanceAmount;
              balanceAmount -= redeemedAmount;
              products.push({
                name: i.name,
                description: i.description,
                qty: i.qty,
                total: -redeemedAmount,
                isDiscount: true
              });
            }
          } else if (i.isRegistration) {
            const saleableItemTotal = r.saleableItems.reduce((acc, item) => acc + this.getTotalWithTransactionFee(item.price) * item.qty, 0);
            let balanceAmount = Math.abs(productTotal - saleableItemTotal);
            redeemedAmount = i.type === 'dollar' ? i.amount : ((i.amount * balanceAmount) / 100);
            if (redeemedAmount > balanceAmount) redeemedAmount = balanceAmount;
            balanceAmount -= redeemedAmount;
            products.push({
              name: i.name,
              description: i.description,
              qty: i.qty,
              total: -redeemedAmount,
              isDiscount: true
            });
          } else {
            let balanceAmount = productTotal;
            redeemedAmount = i.type === 'dollar' ? i.amount : ((i.amount * balanceAmount) / 100);
            if (redeemedAmount > balanceAmount) redeemedAmount = balanceAmount;
            balanceAmount -= redeemedAmount;
            products.push({
              name: i.name,
              description: i.description,
              qty: i.qty,
              total: -redeemedAmount,
              isDiscount: true
            });
          }
        });

        if (r.discountVoucher && r.discountVoucher.length) {
          r.discountVoucher.forEach((voucher) => {
            products.push({
              name: voucher.name,
              description: voucher.description,
              qty: 1,
              total: -voucher.redeemedAmount,
              isDiscount: true,
              voucherType: voucher.voucherType,
            });
          });
        }

        productTotal = products.reduce((acc, p) => acc + p.total, 0);

        return {
          _id: `${r.memberId}${r.product._id}`,
          playerName: `${r.profile.firstName} ${r.profile.lastName}`,
          entityName: r.product.name || r.entityName,
          registrationType: r.entityType,
          entityLevel: r.entityLevel,
          productType: r.productType,
          memberType: r.memberType,
          tags: r.tags,
          products,
          voucherPin: moment(r.profile.dob).format('DDMM'),
          age: calculateMemberAge(r.profile.dob, this.endOfYear),
          total: products.reduce((acc, p) => acc + p.total, 0),
          payAfter: r.product.payAfter,
          minPrice: r.product.minPrice,
          donation: r.product.donation,
          acceptActiveKids: r.acceptActiveKids === true,
          teamName: r.team ? r.team.name : '',
          redeem: r.redeem,
          discountVoucher: [r.discountVoucher],
          allowPayLater: r.product.allowPayLater,
          payLater: false,
          productId: r.product._id,
          memberIds: r.memberIds,
          isBulk: r.isBulk,
        };
      });
      this.$forceUpdate();
    }
  },
  computed: {
    ...mapGetters('national', ['endOfYear']),
    hasCustomEntity() {
      const customEntity = this.$store.getters['national/getEntity'];
      if (customEntity && customEntity.level && customEntity.name) {
        return true;
      }
      return false;
    },
    isNotFirefox() {
      return navigator.userAgent.toLowerCase().indexOf('firefox') === -1;
    },
    canShowApplePay() {
      return window.ApplePaySession && window.ApplePaySession.canMakePayments();
    },
    applePayOptions() {
      return {
        countryCode: 'AU',
        currencyCode: 'AUD',
        total: {
          label: 'Pay & Register',
          amount: this.total / 100,
        },
        supportedNetworks: ['masterCard', 'visa'],
        merchantCapabilities: ['supports3DS', 'supportsCredit', 'supportsDebit']
      };
    },
    googlePayOptions() {
      return {
        ...this.options,
        transactionInfo: {
          totalPriceStatus: 'FINAL',
          totalPrice: this.total,
          currencyCode: 'AUD',
          countryCode: 'AU'
        },
      };
    },
    // ...mapGetters('cart', ['registrations']),
    feePercentage() {
      const defaultFee = this.$store.getters['cart/transactionFee'];
      const preference = this.$store.getters['national/paymentPreference'];
      const { addToTotal } = preference;
      return addToTotal >= 0 ? addToTotal : defaultFee;
    },
    minPayment() {
      const minPayment = _.get(this, 'registrations[0].product.minPrice', 0);
      const { cartTotal } = this;
      return Math.min(minPayment, cartTotal);
    },
    currentDiscounts() {
      return this.$store.getters['cart/regoDiscounts'];
    },
    registrations() {
      return this.$store.getters['cart/registrations'];
    },
    directSaleableItems() {
      return this.$store.getters['cart/directSaleableItems'];
    },
    national() {
      return +process.env.VUE_APP_NATIONAL_ID;
    },
    discountTotal() {
      let total = 0;
      _.forEach(this.summary, (i) => {
        total += _.sumBy(i.products, (x) => (x.isDiscount ? x.total : 0));
      });

      // checkout total discount

      return total + (-this.totalDiscount);
    },
    cartTotal() {
      let total = 0;
      _.forEach(this.summary, (i) => {
        if (i.payAfter && i.payToday > 0) {
          total += i.payToday;
        } else {
          _.forEach(i.products, (p) => {
            if (!i.payLater) {
              total += p.total;
            }
          });
        }
      });
      if (this.summary.every((i) => i.payAfter && i.payToday === 0)) return 0;
      return total > 0 ? total : 0;
    },
    saleableItemTotal() {
      let total = 0;
      _.forEach(this.payment.directSaleableItems, (i) => {
        total += i.price * i.qty;
      });
      return total;
    },
    allCartTotal() {
      return this.cartTotal + this.saleableItemTotal;
    },
    transactionFee() {
      const percent = this.$store.getters['cart/transactionFee'];
      const preference = this.$store.getters['national/paymentPreference'];
      let fee = 0;
      // if ((preference.addToTotal === 0 && preference.addToProduct === 0)) return 0;
      if (preference.addToTotal >= 0) {
        fee = +((this.cartTotal * preference.addToTotal) / 100).toFixed();
      } else if (!(preference.addToProduct >= 0)) {
        // Only use default total if no product or total setting
        fee = +((this.cartTotal * percent) / 100).toFixed();
      }
      return fee;
    },
    saleableItemTransactionFee() {
      const percent = this.$store.getters['cart/transactionFee'];
      const preference = this.$store.getters['national/paymentPreference'];
      let fee = 0;
      if (preference.addToTotal >= 0) {
        fee = +((this.saleableItemTotal * preference.addToTotal) / 100).toFixed();
      } else if (!(preference.addToProduct >= 0)) {
        // Only use default total if no product or total setting
        fee = +((this.saleableItemTotal * percent) / 100).toFixed();
      }
      return fee;
    },
    total() {
      return +((this.cartTotal + this.transactionFee) - this.totalDiscount).toFixed();
    },
    totalSaleableItemsWithFee() {
      return this.saleableItemTotal + this.saleableItemTransactionFee;
    },
    totalWithSaleableItems() {
      return this.total + this.totalSaleableItemsWithFee;
    },

    payTodayTotal() {
      const { cartTotal } = this;
      let percent = 0;
      const defaultTransactionFee = this.$store.getters['cart/transactionFee'];
      const preference = this.$store.getters['national/paymentPreference'];
      if (preference && preference.addToTotal >= 0) {
        percent = preference.addToTotal;
      } else {
        percent = defaultTransactionFee;
      }
      return +(cartTotal + ((cartTotal * percent) / 100));
    },
    requirePayment() {
      return this.allCartTotal > 0 && !(this.summary.length && this.summary.every((i) => i.payAfter) && this.payTodayTotal === 0);
    },
    resCol() {
      return this.requirePayment ? {
        xs: 24, sm: 24, md: 12, lg: 12
      } : {
        xs: 24, sm: 24, md: 24, lg: 24
      };
    },
    fillingAddress() {
      const rego = _.head(this.payment.registrations);
      return _.get(rego, 'profile.address.formatted', false) ? rego.profile.address : false;
    },
    isPayDisabled() {
      return this.payment.registrations.length === 0 && this.payment.directSaleableItems.length === 0;
    },
    paymentTitle() {
      return this.requirePayment ? 'Payment Details' : 'Complete your registration';
    },
    paymentButtonText() {
      return this.requirePayment ? 'Pay & Complete' : 'Register';
    },
    codesInUsed() {
      return this.$store.getters['cart/codesInUsed'];
    },
    cTotalDiscount() {
      const total = _.find(this.regoDiscounts, (discount) => discount.type === 'checkoutTotal');
      return total;
    },
    selectedProductCount() {
      return this.selectedRegos.length;
    },
  },
  filters: {
    parsePrice(val) {
      const rs = (val / 100).toFixed(2);
      if (val < 0) return `-$${(Math.abs(rs)).toFixed(2)}`;
      return `$${rs}`;
    },
    parseProductType(val) {
      return (_.find(productTypes, (pt) => pt.type === val)).name;
    },
    parseEntityName(val) {
      return val.productType === 'indv-to-team' ? `${_.get(val, 'teamName', '')}, ${val.entityName}` : val.entityName;
    },
    cap(val) {
      return _.capitalize(val);
    },
    joinTag(vals) {
      return _.join(_.map(vals, (v) => v.name), ', ');
    }
  },
  watch: {
    regoDiscounts: {
      immediate: true,
      deep: true,
      handler() {
        const checkouts = _.filter(this.regoDiscounts, (discount) => discount.type === 'checkoutTotal');
        const total = _.sumBy(_.map(checkouts, (checkout) => checkout.discountVoucher), 'redeemedAmount');

        this.totalDiscount = total;
      }
    },
    '$store.state.cart.registrations': {
      immediate: true,
      deep: true,
      // eslint-disable-next-line func-names
      handler: function (val) {
        const registrations = _.map(val, (re) => _.assign({}, re, {
          redeem: {
            code: undefined,
            redeemed: false,
            error: undefined
          }
        }));
        console.log('registrations', registrations);
        const filtered = _.filter(registrations, (r) => r.isBulk);
        if (this.payment && this.payment.registrations) this.payment.registrations = filtered;
        else this.$set(this, 'payment.registrations', filtered);
      }
    },
    '$store.state.cart.saleableItems': {
      immediate: true,
      deep: true,
      // eslint-disable-next-line func-names
      handler: function (val) {
        this.payment.directSaleableItems = val;
      }
    },
    // summary: {
    //   immediate: true,
    //   // eslint-disable-next-line object-shorthand, func-names
    //   handler: function (val) {
    //     this.currSummary = val;
    //   }
    // }
    'payment.registrations': {
      immediate: true,
      deep: true,
      // eslint-disable-next-line func-names
      // eslint-disable-next-line object-shorthand
      handler: function (val) {
        this.summary = [];
        _.forEach(val, (r) => {
          console.log('r at bulk', r);
          const products = [
            {
              name: `${_.get(r, 'product.price') > 0 ? 'Registration Fee' : 'Registration'}`,
              qty: r.memberIds.length || 1,
              total: this.getTotalWithTransactionFee(_.get(r, 'product.price') * (r.memberIds.length || 1)),
              price: _.get(r, 'product.price'),
              subProducts: r.subProducts,
            }
          ];
            // Add custom fees if rego has one
          if (_.get(r, 'product.customFees') && _.get(r, 'product.customFees.value') > 0) {
            const qty = _.get(r, 'product.customFees.qty', 1);
            products.push({
              name: r.product.customFees.label === '' ? 'Custom Fee' : r.product.customFees.label,
              qty,
              feeRequired: r.product.customFees.required === undefined ? true : _.get(r, 'product.customFees.required', false),
              isCustomFees: true,
              price: r.product.customFees.value,
              total: this.getTotalWithTransactionFee(r.product.customFees.value * qty),
            });
          }
          let productTotal = _.sumBy(products, 'total');
          if (r.upgradeFromMembership) {
            let feePaid = r.upgradeFromMembership.pricing.membership.price;
            if (feePaid > productTotal) feePaid = productTotal;
            products.push({
              name: 'Membership Upgrade',
              description: `Upgrade from ${r.upgradeFromMembership.regoEntity.name}`,
              qty: 1,
              total: -feePaid,
            });
          }

          _.forEach(r.saleableItems, (i) => {
            if (i.qty > 0) {
              products.push({
                name: i.name,
                description: i.description,
                isSaleableItem: true,
                price: i.price,
                _id: i._id,
                qty: i.qty,
                total: this.getTotalWithTransactionFee((i.price * i.qty)),
              });
            }
          });

          productTotal = _.sumBy(products, 'total');

          if (r.activeKidsVoucher) {
            products.push({
              name: 'Active Kids Voucher',
              description: '',
              qty: 1,
              total: -r.activeKidsVoucher.redeemedAmount,
              isVoucher: true
            });
          }

          if (r.additionalActiveKidsVoucher) {
            products.push({
              name: 'Additional Active Kids Voucher',
              description: '',
              qty: 1,
              total: -r.additionalActiveKidsVoucher.redeemedAmount,
              isVoucher: true
            });
          }

          let balanceAmount;
          _.forEach(r.discounts, (i) => {
            let redeemedAmount = 0;
            if (i.isSaleableItem) {
              const foundItemIndex = _.findIndex(r.saleableItems, (s) => s._id === i.saleableItem);
              if (foundItemIndex > -1) {
                balanceAmount = this.getTotalWithTransactionFee(r.saleableItems[foundItemIndex].price) * r.saleableItems[foundItemIndex].qty;
                redeemedAmount = i.type === 'dollar' ? i.amount : ((i.amount * balanceAmount) / 100);
                if (redeemedAmount > balanceAmount) redeemedAmount = balanceAmount;
                balanceAmount -= redeemedAmount;
                products.push({
                  name: i.name,
                  description: i.description,
                  qty: i.qty,
                  total: -redeemedAmount,
                  isDiscount: true
                });
              }
            } else if (i.isRegistration) {
              const saleableItemTotal = _.sumBy(r.saleableItems, (item) => this.getTotalWithTransactionFee(item.price) * item.qty);
              balanceAmount = Math.abs(productTotal - saleableItemTotal);
              redeemedAmount = i.type === 'dollar' ? i.amount : ((i.amount * balanceAmount) / 100);
              if (redeemedAmount > balanceAmount) redeemedAmount = balanceAmount;
              balanceAmount -= redeemedAmount;
              products.push({
                name: i.name,
                description: i.description,
                qty: i.qty,
                total: -redeemedAmount,
                isDiscount: true
              });
            } else {
              balanceAmount = productTotal;
              redeemedAmount = i.type === 'dollar' ? i.amount : ((i.amount * balanceAmount) / 100);
              if (redeemedAmount > balanceAmount) redeemedAmount = balanceAmount;
              balanceAmount -= redeemedAmount;
              products.push({
                name: i.name,
                description: i.description,
                qty: i.qty,
                total: -redeemedAmount,
                isDiscount: true
              });
            }
          });

          if (r.discountVoucher && r.discountVoucher.length) {
            _.forEach(r.discountVoucher, (voucher) => {
              products.push({
                name: voucher.name,
                description: voucher.description,
                qty: 1,
                total: -voucher.redeemedAmount,
                isDiscount: true,
                voucherType: voucher.voucherType,
              });
            });
          }

          productTotal = _.sumBy(products, 'total');

          if (r.productType !== 'family') {
            this.summary.push({
              _id: `${r.memberId}${r.product._id}`,
              playerName: `${r.profile.firstName} ${r.profile.lastName}`,
              entityName: r.product.name || r.entityName,
              registrationType: r.entityType,
              entityLevel: r.entityLevel,
              productType: r.productType,
              memberType: r.memberType,
              tags: r.tags,
              products,
              voucherPin: moment(r.profile.dob).format('DDMM'),
              age: calculateMemberAge(r.profile.dob, this.endOfYear),
              total: _.sumBy(products, 'total'),
              payAfter: r.product.payAfter,
              minPrice: r.product.minPrice,
              donation: r.product.donation,
              acceptActiveKids: r.acceptActiveKids === true,
              teamName: _.get(r, 'team.name'),
              redeem: r.redeem,
              discountVoucher: [r.discountVoucher],
              allowPayLater: r.product.allowPayLater,
              payLater: false,
              productId: r.product._id,
              memberIds: r.memberIds,
              isBulk: r.isBulk,
            });
          } else {
            const memberDetails = _.map((r.familyRegistrations), (rego) => ({
              playerName: `${rego.profile.firstName} ${rego.profile.lastName}`,
              age: calculateMemberAge(rego.profile.dob, this.endOfYear),
              memberType: rego.memberType,
            }));

            const familyMemberIds = _.map((r.familyRegistrations), (f) => f.memberId);

            this.summary.push({
              _id: `${_.join(_.map(familyMemberIds, String), '')}${r.product._id}`,
              memberDetails,
              // playerNames: `${r.profile.firstName} ${r.profile.lastName}`,
              entityName: r.product.name || r.entityName,
              registrationType: r.entityType,
              entityLevel: r.entityLevel,
              productType: r.productType,
              // memberType: r.memberType,
              tags: r.tags,
              products,
              // voucherPin: moment(r.profile.dob).format('DDMM'),
              // age: calculateMemberAge(r.profile.dob, this.endOfYear),
              total: _.sumBy(products, 'total'),
              payAfter: r.product.payAfter,
              minPrice: r.product.minPrice,
              donation: r.product.donation,
              acceptActiveKids: r.acceptActiveKids === true,
              teamName: _.get(r, 'team.name'),
              redeem: r.redeem,
              discountVoucher: [r.discountVoucher],
            });
          }
        });
        this.originalSummary = _.cloneDeep(this.summary);
        this.$forceUpdate();
      }
    },

  }
};
</script>

  <style scoped lang="scss">
.compact-card {
  padding: 10px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  background-color: white;
  margin-bottom: 10px;
}

.card-content {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  position: relative;
}

.card-item {
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  color: #333;
  flex: 1 1 calc(50% - 20px); /* Two items per line with gap */
}

.card-item .title {
  font-weight: bold;
  color: #888; /* Lighter color for labels */
}

.vertical-divider {
  display: none;
}

@media (min-width: 769px) {
  .vertical-divider {
    display: block;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 50%;
    width: 1px;
    background-color: #ddd;
  }
}

@media (max-width: 768px) {
  .card-item {
    flex: 1 1 100%; /* One item per line on smaller screens */
  }
}

  ::v-deep apple-pay-button {
    --apple-pay-button-width: 150px;
    --apple-pay-button-height: 42px !important;
    --apple-pay-button-border-radius: 6px !important;
    --apple-pay-button-padding: 0px 0px;
    --apple-pay-button-box-sizing: border-box;
  }

  .vendor-payment {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 1rem;
    justify-content: center;
    &.single {
      grid-template-columns: 1fr;
    }
  }

  @media (max-width: 768px) {
    .vendor-payment {
      display: grid;
      grid-template-columns: 1fr;
      gap: 1rem;
    }
  }

  .payment-container {
    width: 100%;
    max-width: $lg;
  }

  .sub-products-list {
    padding-left: 20px; /* Indent the subproducts list */
  }

  .sub-products-title {
    font-weight: bold;
    margin-bottom: 5px;
  }

  .sub-products-names {
    list-style-type: none; /* Remove bullet points */
    padding: 0;
  }

  .sub-products-names li {
    margin-bottom: 5px; /* Space out the subproduct names */
  }

  .inline-list {
    list-style-type: none; /* Remove bullet points */
    padding: 0;
    display: flex; /* Display list items inline */
    flex-wrap: wrap; /* Wrap onto the next line if space runs out */
    gap: 10px; /* Space between items */
  }

  .inline-list li {
    margin-bottom: 5px; /* Space below each item if wrapped */
  }

  ::v-deep .el-card__body {
    width: 100%;
    max-width: 100% !important;
  }

  ::v-deep .item-table {
    border: 1px solid rgba(45, 58, 69, 0.1);

    th {
      background: #F6F8FA !important;
      padding: 1em;
      text-align: left;
    }

    td {
      background-color: white !important;
      padding: 0.6em 1em;
    }

    .product-info {
      .name {
        // color: #2D3A45;
        font-size: 1em;
      }
      .keepword{
        word-break: keep-all;
      }

      .description {
        font-size: 0.8em;
        font-family: $fontLight;
      }
    }
  }

  .title {
    font-weight: bold;
    margin-right: 0.3em;
    // color: $primary;
  }
  .header{
    font-size: 1.2em;
    font-weight: bold;
    margin-right: 0.3em;
  }

  .bottomBtn {
    max-width: 100%;
    width: 10em;
  }

  .payBtn {
    max-width: 100%;
    width: 15em;
  }

  apple-pay-button {
    --apple-pay-button-width: 150px;
    --apple-pay-button-height: 46px;
    --apple-pay-button-border-radius: 100vh;
    --apple-pay-button-padding: 0px 0px;
    --apple-pay-button-box-sizing: border-box;
    display: initial;
    width: 240px;
    height: 46px !important;
  }
  .pay-later-wrapper {
    padding: 10px 10px 30px 10px;
    margin-bottom: 10px;
    border-radius: 10px;
    position: relative;
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
    border: 1px solid #ccc;
  }

  .pay-later-selected {
    border-color: #28a745; /* Green border to indicate Pay Later */
  }

  .pay-later-checkbox {
    position: absolute;
    bottom: 7px;
    right: 10px;
    z-index: 2; /* Ensure checkbox is above the card */
  }
  .pay-later-text {
    position: absolute;
    bottom: 7px;
    left: 10px;
    z-index: 2; /* Ensure checkbox is above the card */
    color: #2D3A45;
    font-size: 0.9em;
  }

  .card-container {
    position: relative;
  }

  .card-header {
    padding: 10px;
    background-color: #fff;
    border-bottom: 1px solid #ccc;
  }

  .card-body-container {
    position: relative;
    padding: 20px; /* Match the padding of el-card__body */
  }

  // .card-body {
  //   padding: 0; /* Remove padding from card-body to avoid double padding */
  // }

  .blurred-content {
    filter: blur(3px);
    // background-color: #f0f0f0;
    z-index: 1; /* Ensure card content is below the overlay */
  }

  .overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.25);
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 10px;
    pointer-events: none;
    z-index: 2; /* Ensure overlay is above the card content */
  }

  .overlay-text {
    font-size: 1.5em;
    font-weight: bold;
    z-index: 4; /* Ensure overlay text is above everything */
  }
  </style>
